import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Date` scalar type represents a year, month and day in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  Date: any;
  /** The `DateTime` scalar type represents a date and time. `DateTime` expects timestamps to be formatted in accordance with the [ISO-8601](https://en.wikipedia.org/wiki/ISO_8601) standard. */
  DateTime: any;
  Decimal: any;
};

export enum AdditiveDateApplicationMethod {
  Day = 'DAY',
  Month = 'MONTH'
}

export type Address = {
  city?: Maybe<City>;
  complement?: Maybe<Scalars['String']>;
  neighbourhood?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  cityId?: InputMaybe<Scalars['ID']>;
  complement?: InputMaybe<Scalars['String']>;
  neighbourhood?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AlienatedItem = {
  description?: Maybe<Scalars['String']>;
  fabricator?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  serialNumber?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type AlienatedItemInput = {
  description?: InputMaybe<Scalars['String']>;
  fabricator?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type AmountRequestedInput = {
  amountRequested?: InputMaybe<Scalars['Decimal']>;
};

export type AmountRestriction = {
  applicationMethod?: Maybe<RestrictionApplicationMethod>;
  value: Scalars['Decimal'];
};

export type AmountRestrictionInput = {
  applicationMethod?: InputMaybe<RestrictionApplicationMethod>;
  value: Scalars['Decimal'];
};

export type Analyst = {
  creationDate?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  login?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  slackId?: Maybe<Scalars['String']>;
};

export type AnalystInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  login: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  slackId?: InputMaybe<Scalars['String']>;
};

export type AnalystUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  slackId?: InputMaybe<Scalars['String']>;
};

export type AntiFraud = {
  applicant?: Maybe<Applicant>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  livenessStatus?: Maybe<LivenessStatus>;
  worthyCreditStatus?: Maybe<WorthyCreditStatus>;
};

export type Applicant = {
  relationship?: Maybe<ApplicantRelationship>;
};

export enum ApplicantRelationship {
  NonRequestingPartner = 'NON_REQUESTING_PARTNER',
  RequestingPartner = 'REQUESTING_PARTNER',
  UnknownNonRequestingPartner = 'UNKNOWN_NON_REQUESTING_PARTNER',
  UnknownRequestingPartner = 'UNKNOWN_REQUESTING_PARTNER'
}

export enum ApplicationRelationshipType {
  Fallback = 'FALLBACK'
}

export type ApplyForLoanResult = {
  cnpjErrorReason?: Maybe<CnpjErrorReason>;
  daysLeft?: Maybe<Scalars['Int']>;
  result?: Maybe<Scalars['Boolean']>;
};

export enum ArrangementType {
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD',
  Purchase = 'PURCHASE'
}

export enum AutomaticDebitLiquidationMethod {
  InterBankTransfer = 'INTER_BANK_TRANSFER',
  IntraBankTransfer = 'INTRA_BANK_TRANSFER'
}

export type Bank = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mostUsed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type BankAccount = {
  account?: Maybe<Scalars['String']>;
  agency?: Maybe<Scalars['String']>;
  bank?: Maybe<Bank>;
  bankId?: Maybe<Scalars['ID']>;
  isAutomaticDebit?: Maybe<Scalars['Boolean']>;
  isBizConta?: Maybe<Scalars['Boolean']>;
  isLegalPersonAccount?: Maybe<Scalars['Boolean']>;
};

export type BankAccountInput = {
  account: Scalars['String'];
  agency: Scalars['String'];
  bankId?: InputMaybe<Scalars['ID']>;
};

export type BankInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mostUsed?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BizOnSettings = {
  cAFAuthToken?: Maybe<Scalars['String']>;
  cAFBaseUrl?: Maybe<Scalars['String']>;
  /** @deprecated Replaced by TemplateId */
  cAFReportId?: Maybe<Scalars['String']>;
  cAFTemplateId?: Maybe<Scalars['String']>;
};

export type BizScdInstitution = {
  bizId?: Maybe<FinancialInstitutionIdentification>;
  ccbNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Bizu = {
  bizuIndicator?: Maybe<Scalars['String']>;
  bizuScore?: Maybe<Scalars['Float']>;
  bizuVersion?: Maybe<Scalars['Int']>;
};

export type Borrower = {
  address?: Maybe<Address>;
  averageReceivablesAmount?: Maybe<Scalars['Float']>;
  bankAccount?: Maybe<BankAccount>;
  companyDocument?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalRelationships?: Maybe<Array<Maybe<ExternalRelationship>>>;
  financialInstitution?: Maybe<FinancialInstitutionRelationshipType>;
  foundationDate?: Maybe<Scalars['Date']>;
  legacyRelationship?: Maybe<LegacyRelationship>;
  monthlyRevenue?: Maybe<Scalars['Decimal']>;
  phone?: Maybe<Scalars['String']>;
  relationship?: Maybe<BorrowerRelationship>;
  responsibleDocument?: Maybe<Scalars['String']>;
  responsibleName?: Maybe<Scalars['String']>;
  simplesNacional?: Maybe<Scalars['Boolean']>;
  stateRegistration?: Maybe<Scalars['String']>;
};

export type BorrowerCredit = {
  companyDocument?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  foundationDate?: Maybe<Scalars['Date']>;
  monthlyRevenue?: Maybe<Scalars['Decimal']>;
  phone?: Maybe<Scalars['String']>;
  responsibleDocument?: Maybe<Scalars['String']>;
  responsibleName?: Maybe<Scalars['String']>;
  simplesNacional?: Maybe<Scalars['Boolean']>;
  stateRegistration?: Maybe<Scalars['String']>;
};

export type BorrowerInput = {
  address?: InputMaybe<AddressInput>;
  averageReceivablesAmount?: InputMaybe<Scalars['Float']>;
  bankAccount?: InputMaybe<BankAccountInput>;
  companyDocument?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  legacyRelationship?: InputMaybe<LegacyRelationshipInput>;
  monthlyRevenue?: InputMaybe<Scalars['Decimal']>;
  phone?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<BorrowerRelationship>;
  responsibleDocument?: InputMaybe<Scalars['String']>;
  responsibleName?: InputMaybe<Scalars['String']>;
  simplesNacional?: InputMaybe<Scalars['Boolean']>;
};

export enum BorrowerPosition {
  NotPartner = 'NOT_PARTNER',
  Partner = 'PARTNER',
  Unknown = 'UNKNOWN'
}

export enum BorrowerRelationship {
  Administrator = 'ADMINISTRATOR',
  Attorney = 'ATTORNEY',
  FinanceManager = 'FINANCE_MANAGER',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  PartnerAdministrator = 'PARTNER_ADMINISTRATOR',
  President = 'PRESIDENT'
}

export type CheckUserEmailResult = {
  result?: Maybe<Scalars['Boolean']>;
};

export type City = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  state: State;
};

export type CityInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  stateId: Scalars['ID'];
};

export enum ClientCategory {
  Other = 'OTHER',
  Prime = 'PRIME',
  SuperPrime = 'SUPER_PRIME'
}

export enum CnpjErrorReason {
  CantRenew = 'CANT_RENEW',
  OfferInProgress = 'OFFER_IN_PROGRESS',
  RequestDenied = 'REQUEST_DENIED',
  Unknow = 'UNKNOW'
}

export type ComissionDiscount = {
  additiveDate?: Maybe<GracePeriodDiscountAdditiveDate>;
  allowsRenegotiation: Scalars['Boolean'];
  applicationMethod?: Maybe<DiscountApplicationMethod>;
  dateRanges?: Maybe<Array<Maybe<GracePeriodDiscountDateRange>>>;
  fixedDate?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type ComissionDiscountInput = {
  applicationMethod?: InputMaybe<DiscountApplicationMethod>;
  value: Scalars['Decimal'];
};

export enum CommissionMode {
  Composed = 'COMPOSED',
  Fixed = 'FIXED'
}

export type CompanyInfo = {
  borrower?: Maybe<BorrowerCredit>;
  creditAnalyst?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastCreditAnalysis?: Maybe<CreditAnalysis>;
};

export type CompanyInformationInput = {
  companyDocument: Scalars['String'];
  monthlyRevenue?: InputMaybe<Scalars['Decimal']>;
  relationship?: InputMaybe<BorrowerRelationship>;
};

export type CompanyInputType = {
  cnpj?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  monthlyRevenue?: InputMaybe<Scalars['Decimal']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CompanyType = {
  cnpj?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  monthlyRevenue?: Maybe<Scalars['Decimal']>;
  name?: Maybe<Scalars['String']>;
};

export type CompanyUser = {
  company?: InputMaybe<CompanyInputType>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type CompanyUserType = {
  company?: Maybe<CompanyType>;
  userId?: Maybe<Scalars['Int']>;
};

export type Coupon = {
  allowsUnlimitedUses: Scalars['Boolean'];
  amountUsed?: Maybe<Scalars['Int']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  discounts?: Maybe<Array<Maybe<DiscountType>>>;
  enabled: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  loanApplicationId?: Maybe<Scalars['ID']>;
  restrictions?: Maybe<Array<Maybe<RestrictionType>>>;
  statusValue?: Maybe<Scalars['String']>;
  totalAvailable?: Maybe<Scalars['Int']>;
  usedIn?: Maybe<Scalars['DateTime']>;
  validFrom?: Maybe<Scalars['DateTime']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type CouponInput = {
  allowsUnlimitedUses: Scalars['Boolean'];
  code: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  usedIn?: InputMaybe<Scalars['DateTime']>;
  validFrom?: InputMaybe<Scalars['DateTime']>;
  validUntil?: InputMaybe<Scalars['DateTime']>;
};

export type CouponPagination = {
  coupons?: Maybe<Array<Maybe<Coupon>>>;
  current: Scalars['Int'];
  pageSize: Scalars['Int'];
  total?: Maybe<Scalars['Int']>;
};

export type CreditAnalysis = {
  status?: Maybe<CreditAnalysisStatus>;
};

export enum CreditAnalysisStatus {
  Approved = 'APPROVED',
  CreditInvestigation = 'CREDIT_INVESTIGATION',
  FirstAuthority = 'FIRST_AUTHORITY',
  PreAuthority = 'PRE_AUTHORITY',
  Replaced = 'REPLACED',
  Repproved = 'REPPROVED',
  SecondAuthority = 'SECOND_AUTHORITY',
  ThirdAuthority = 'THIRD_AUTHORITY'
}

export type CreditWorthiness = {
  bizu?: Maybe<Bizu>;
  bizu3?: Maybe<Bizu>;
  bizuComboZoneNumber?: Maybe<Scalars['Int']>;
  clientCategory?: Maybe<ClientCategory>;
  loanApplicationId?: Maybe<Scalars['ID']>;
  lowTicket?: Maybe<LowTicketType>;
  probability?: Maybe<Scalars['Float']>;
  processingEnd?: Maybe<Scalars['DateTime']>;
  processingStart?: Maybe<Scalars['DateTime']>;
  renewalScore3?: Maybe<RenewalScore>;
  score?: Maybe<Scalars['Int']>;
  serasa?: Maybe<Serasa>;
};

export enum Creditor {
  Bizcapital = 'BIZCAPITAL',
  Others = 'OTHERS'
}

export type DataFillOutFlowStep = {
  order?: Maybe<Scalars['Int']>;
  routerPath?: Maybe<Scalars['String']>;
};

export enum DiscountApplicationMethod {
  Absolute = 'ABSOLUTE',
  Additive = 'ADDITIVE',
  Proportional = 'PROPORTIONAL',
  Relative = 'RELATIVE'
}

export type DiscountType = ComissionDiscount | GracePeriodDiscount | InterestRateDiscount;

export enum DocumentType {
  CertificateOfIncorporation = 'CERTIFICATE_OF_INCORPORATION',
  CndPge = 'CND_PGE',
  CndPgm = 'CND_PGM',
  CndSefaz = 'CND_SEFAZ',
  CndTst = 'CND_TST',
  CompanyBankStatement = 'COMPANY_BANK_STATEMENT',
  CompanyCnpjRegularity = 'COMPANY_CNPJ_REGULARITY',
  CompanyMateriality = 'COMPANY_MATERIALITY',
  CompanyProofOfAddress = 'COMPANY_PROOF_OF_ADDRESS',
  CompanyProofOfIncome = 'COMPANY_PROOF_OF_INCOME',
  ConfirmationAudio = 'CONFIRMATION_AUDIO',
  DeathCertificate = 'DEATH_CERTIFICATE',
  DownPaymentReceipt = 'DOWN_PAYMENT_RECEIPT',
  FgtsRegularityCertificate = 'FGTS_REGULARITY_CERTIFICATE',
  IndividualEntrepreneurCertificate = 'INDIVIDUAL_ENTREPRENEUR_CERTIFICATE',
  Invoice = 'INVOICE',
  LaborMinistryRegularityCertificate = 'LABOR_MINISTRY_REGULARITY_CERTIFICATE',
  MicroBusinessesCertificate = 'MICRO_BUSINESSES_CERTIFICATE',
  OperatingLicense = 'OPERATING_LICENSE',
  PartnerBankStatement = 'PARTNER_BANK_STATEMENT',
  PartnerCpf = 'PARTNER_CPF',
  PartnerCpfRegularity = 'PARTNER_CPF_REGULARITY',
  PartnerDigitalDriverLicense = 'PARTNER_DIGITAL_DRIVER_LICENSE',
  PartnerDriverLicence = 'PARTNER_DRIVER_LICENCE',
  PartnerDriverLicenceVerse = 'PARTNER_DRIVER_LICENCE_VERSE',
  PartnerIdentity = 'PARTNER_IDENTITY',
  PartnerIdentityVerse = 'PARTNER_IDENTITY_VERSE',
  PartnerIncomeStatement = 'PARTNER_INCOME_STATEMENT',
  PartnerIncomeTaxReturn = 'PARTNER_INCOME_TAX_RETURN',
  PartnerMarriageCertificate = 'PARTNER_MARRIAGE_CERTIFICATE',
  PartnerProofOfAddress = 'PARTNER_PROOF_OF_ADDRESS',
  PartnerProofOfIncome = 'PARTNER_PROOF_OF_INCOME',
  PartnerSelfie = 'PARTNER_SELFIE',
  PgfnRegularityCertificate = 'PGFN_REGULARITY_CERTIFICATE',
  SebraeCertificate = 'SEBRAE_CERTIFICATE',
  Unknown = 'UNKNOWN'
}

export type EscrowBankAccount = {
  account?: Maybe<Scalars['String']>;
  accountDigit?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bizContaId?: Maybe<Scalars['ID']>;
  branch?: Maybe<Scalars['String']>;
  branchDigit?: Maybe<Scalars['String']>;
  brazilianPaymentSystemId?: Maybe<Scalars['String']>;
  responsibleDocument?: Maybe<Scalars['String']>;
  responsibleName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type EscrowBankAccountInput = {
  account?: InputMaybe<Scalars['String']>;
  accountDigit?: InputMaybe<Scalars['String']>;
  bankCode?: InputMaybe<Scalars['String']>;
  bizContaId?: InputMaybe<Scalars['ID']>;
  branch?: InputMaybe<Scalars['String']>;
  branchDigit?: InputMaybe<Scalars['String']>;
  brazilianPaymentSystemId?: InputMaybe<Scalars['String']>;
  responsibleDocument?: InputMaybe<Scalars['String']>;
  responsibleName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type ExternalRelationship = {
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalSource?: Maybe<ExternalSource>;
  externalStatus?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
};

export type ExternalRelationshipInput = {
  description?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  externalSource: ExternalSource;
  externalStatus?: InputMaybe<Scalars['String']>;
};

export enum ExternalSource {
  FinancialInstitution = 'FINANCIAL_INSTITUTION',
  Partner = 'PARTNER'
}

export type FinancialInstitution = {
  allowedPortfolios?: Maybe<Array<Maybe<Scalars['ID']>>>;
  bizId?: Maybe<FinancialInstitutionIdentification>;
  fallbackPortfolio?: Maybe<Scalars['ID']>;
};

export enum FinancialInstitutionIdentification {
  Bizbank = 'BIZBANK',
  Bmp = 'BMP',
  OpenScd = 'OPEN_SCD',
  Qitech = 'QITECH',
  Socinal = 'SOCINAL'
}

export type FinancialInstitutionRelationshipType = BizScdInstitution | MoneyPlusInstitution | OpenScdInstitution | SocinalInstitution;

export type FixedCommissionPercent = {
  fixedRate?: Maybe<Scalars['Decimal']>;
};

export type FixedCommissionPercentInput = {
  fixedRate?: InputMaybe<Scalars['Decimal']>;
};

export type FollowUp = {
  contactDate?: Maybe<Scalars['DateTime']>;
};

export type Grace = {
  canChange?: Maybe<Scalars['Boolean']>;
  period?: Maybe<Scalars['Int']>;
  periodicity?: Maybe<GracePeriodicity>;
};

export type GracePeriodDiscount = {
  additiveDate?: Maybe<GracePeriodDiscountAdditiveDate>;
  allowsRenegotiation: Scalars['Boolean'];
  applicationMethod?: Maybe<DiscountApplicationMethod>;
  dateRanges?: Maybe<Array<Maybe<GracePeriodDiscountDateRange>>>;
  fixedDate?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type GracePeriodDiscountAdditiveDate = {
  amount: Scalars['Int'];
  applicationMethod?: Maybe<AdditiveDateApplicationMethod>;
};

export type GracePeriodDiscountAdditiveDateInput = {
  amount: Scalars['Int'];
  applicationMethod?: InputMaybe<AdditiveDateApplicationMethod>;
};

export type GracePeriodDiscountDateRange = {
  maxDate?: Maybe<Scalars['DateTime']>;
  minDate?: Maybe<Scalars['DateTime']>;
  proposedPaymentDay?: Maybe<Scalars['DateTime']>;
};

export type GracePeriodDiscountDateRangeInput = {
  maxDate?: InputMaybe<Scalars['DateTime']>;
  minDate?: InputMaybe<Scalars['DateTime']>;
  proposedPaymentDay?: InputMaybe<Scalars['DateTime']>;
};

export type GracePeriodDiscountInput = {
  additiveDate?: InputMaybe<GracePeriodDiscountAdditiveDateInput>;
  applicationMethod?: InputMaybe<DiscountApplicationMethod>;
  dateRanges?: InputMaybe<Array<InputMaybe<GracePeriodDiscountDateRangeInput>>>;
  fixedDate?: InputMaybe<Scalars['Date']>;
};

export enum GracePeriodicity {
  Days = 'DAYS',
  Months = 'MONTHS'
}

export type IsAnalystSettings = {
  analysts?: Maybe<Array<Maybe<ProductIsAnalyst>>>;
  autoAssignment?: Maybe<Scalars['Boolean']>;
  scoreResetDate?: Maybe<Scalars['DateTime']>;
};

export type IsAnalystSettingsInput = {
  analysts: Array<ProductIsAnalystInput>;
  autoAssignment: Scalars['Boolean'];
  scoreResetDate?: InputMaybe<Scalars['DateTime']>;
};

export type InsideSalesAnnotation = {
  annotation?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  insideSalesAnalyst?: Maybe<Scalars['String']>;
};

export type InsideSalesAnnotationInput = {
  annotation?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  insideSalesAnalyst?: InputMaybe<Scalars['String']>;
};

export type InsuranceOptIn = {
  accepted?: Maybe<Scalars['Boolean']>;
};

export type InsuranceOptInInput = {
  accepted?: InputMaybe<Scalars['Boolean']>;
};

export type InterestRateDiscount = {
  additiveDate?: Maybe<GracePeriodDiscountAdditiveDate>;
  allowsRenegotiation: Scalars['Boolean'];
  applicationMethod?: Maybe<DiscountApplicationMethod>;
  dateRanges?: Maybe<Array<Maybe<GracePeriodDiscountDateRange>>>;
  fixedDate?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type InterestRateDiscountInput = {
  applicationMethod?: InputMaybe<DiscountApplicationMethod>;
  value: Scalars['Decimal'];
};

export type LeadStatistic = {
  conversionValue: Scalars['Float'];
};

export type LegacyRelationship = {
  clientId?: Maybe<Scalars['ID']>;
  leadId?: Maybe<Scalars['ID']>;
  loanRequestId?: Maybe<Scalars['ID']>;
  offerId?: Maybe<Scalars['ID']>;
  signerId?: Maybe<Scalars['ID']>;
};

export type LegacyRelationshipInput = {
  clientId?: InputMaybe<Scalars['ID']>;
  leadId?: InputMaybe<Scalars['ID']>;
  offerId?: InputMaybe<Scalars['ID']>;
};

export type Liveness = {
  status?: Maybe<LivenessStatus>;
};

export type LivenessSharedUrl = {
  url?: Maybe<Scalars['String']>;
};

export enum LivenessStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  PendingOcr = 'PENDING_OCR',
  Proccessing = 'PROCCESSING',
  Reproved = 'REPROVED',
  Unknown = 'UNKNOWN'
}

export type LoanApplication = {
  acceptedBizOsAccount?: Maybe<Scalars['Boolean']>;
  acceptedProposal?: Maybe<Proposal>;
  alienatedItems?: Maybe<Array<Maybe<AlienatedItem>>>;
  amountRequested?: Maybe<Scalars['Decimal']>;
  approvedProposal?: Maybe<Proposal>;
  borrower?: Maybe<Borrower>;
  companyInfo?: Maybe<CompanyInfo>;
  couponCode?: Maybe<Scalars['String']>;
  creditAnalyst?: Maybe<Scalars['String']>;
  creditWorthiness?: Maybe<CreditWorthiness>;
  date?: Maybe<Scalars['DateTime']>;
  deniedReason?: Maybe<LoanApplicationDeniedReason>;
  disbursementAuthorizationAllowed?: Maybe<Scalars['Boolean']>;
  documentsAnalyst?: Maybe<Scalars['String']>;
  downPayment?: Maybe<Scalars['Float']>;
  escrowBankAccount?: Maybe<EscrowBankAccount>;
  financialInstitution?: Maybe<FinancialInstitutionIdentification>;
  followUp?: Maybe<Array<Maybe<FollowUp>>>;
  hasAntiFraudWorkflow?: Maybe<Scalars['Boolean']>;
  hasDocumentationUploadWorkflow?: Maybe<Scalars['Boolean']>;
  hasPreviousApplication?: Maybe<Scalars['Boolean']>;
  hasRenegotiation?: Maybe<Scalars['Boolean']>;
  hasRenewalInformation?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  insideSalesAnalyst?: Maybe<Scalars['String']>;
  insideSalesAnnotations?: Maybe<Array<Maybe<InsideSalesAnnotation>>>;
  isEligibleForInsurance?: Maybe<Scalars['Boolean']>;
  lastFollowUp?: Maybe<FollowUp>;
  lastProposal?: Maybe<Proposal>;
  legacyRelationship?: Maybe<LegacyRelationship>;
  lossReason?: Maybe<LossReason>;
  mandatorySettlementArrangements?: Maybe<Array<Maybe<MandatorySettlementArrangement>>>;
  notification?: Maybe<Notification>;
  outboundOriginatorLoanApplicationRef?: Maybe<LoanApplicationRef>;
  partner?: Maybe<Partner>;
  preQualifiedProposal?: Maybe<PreQualifiedProposalType>;
  previousApplication?: Maybe<PreviousApplication>;
  product?: Maybe<Product>;
  productRef?: Maybe<ProductRef>;
  proposals?: Maybe<Array<Maybe<Proposal>>>;
  reason?: Maybe<LoanApplicationReason>;
  reasonDetail?: Maybe<Scalars['String']>;
  reasonValue?: Maybe<Scalars['String']>;
  receivablesBacked?: Maybe<Scalars['Boolean']>;
  renewalInformation?: Maybe<RenewalInformation>;
  simulatedProposals?: Maybe<SimulatedProposals>;
  status?: Maybe<LoanApplicationStatus>;
  tags?: Maybe<Array<Maybe<MetadataTag>>>;
  termsRequested?: Maybe<Scalars['Int']>;
  tracking?: Maybe<Tracking>;
};

export enum LoanApplicationDeniedReason {
  Age = 'AGE',
  Analysis = 'ANALYSIS',
  Bizu = 'BIZU',
  CantRenewal = 'CANT_RENEWAL',
  ClosedFunding_2023 = 'CLOSED_FUNDING_2023',
  Cnae = 'CNAE',
  Committee = 'COMMITTEE',
  CompanyInapt = 'COMPANY_INAPT',
  CompanyLiquidated = 'COMPANY_LIQUIDATED',
  CompanySuspended = 'COMPANY_SUSPENDED',
  CreditRestriction = 'CREDIT_RESTRICTION',
  CreditScore = 'CREDIT_SCORE',
  Duplicated = 'DUPLICATED',
  Eligibility = 'ELIGIBILITY',
  ExtinctCompany = 'EXTINCT_COMPANY',
  FinancialLeverage = 'FINANCIAL_LEVERAGE',
  Fraud = 'FRAUD',
  InQueue = 'IN_QUEUE',
  LowTicket = 'LOW_TICKET',
  Mei = 'MEI',
  PreApproval = 'PRE_APPROVAL',
  ProposalScore = 'PROPOSAL_SCORE',
  Receivables = 'RECEIVABLES',
  ReceivablesEncumbrance = 'RECEIVABLES_ENCUMBRANCE',
  Region = 'REGION',
  RequesterNotStakeholder = 'REQUESTER_NOT_STAKEHOLDER',
  RequesterPoliticallyExposed = 'REQUESTER_POLITICALLY_EXPOSED',
  RequesterReachedLimitOfConcurrentOperations = 'REQUESTER_REACHED_LIMIT_OF_CONCURRENT_OPERATIONS',
  Revenue = 'REVENUE',
  RevenueTooHigh = 'REVENUE_TOO_HIGH',
  ScrCnpj = 'SCR_CNPJ',
  ScrCpf = 'SCR_CPF',
  Serasa = 'SERASA',
  SuspendedCompany = 'SUSPENDED_COMPANY'
}

export type LoanApplicationFromPreQualifiedInput = {
  borrower?: InputMaybe<PreQualifiedBorrowerInput>;
  owner?: InputMaybe<PreQualifiedLoanOwner>;
  preQualifiedLoanId?: InputMaybe<Scalars['ID']>;
  tracking?: InputMaybe<PreQualifiedTrackingInput>;
};

export type LoanApplicationInput = {
  acceptedProposal?: InputMaybe<ProposalInput>;
  amountRequested?: InputMaybe<Scalars['Decimal']>;
  automaticApplication?: InputMaybe<Scalars['Boolean']>;
  borrower?: InputMaybe<BorrowerInput>;
  date?: InputMaybe<Scalars['DateTime']>;
  downPayment?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  legacyRelationship?: InputMaybe<LegacyRelationshipInput>;
  notification?: InputMaybe<NotificationInput>;
  outboundOriginatorLoanApplicationRef?: InputMaybe<LoanApplicationRefInput>;
  partnerRef?: InputMaybe<PartnerRef>;
  productId?: InputMaybe<Scalars['ID']>;
  reason?: InputMaybe<LoanApplicationReason>;
  reasonDetail?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<LoanApplicationStatus>;
  termsRequested?: InputMaybe<Scalars['Int']>;
  tracking?: InputMaybe<TrackingInput>;
};

export type LoanApplicationPagination = {
  currentPage: Scalars['Int'];
  pageSize: Scalars['Int'];
  records?: Maybe<Array<Maybe<LoanApplication>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum LoanApplicationReason {
  DebtConsolidation = 'DEBT_CONSOLIDATION',
  EquipmentPurchase = 'EQUIPMENT_PURCHASE',
  Expansion = 'EXPANSION',
  MarketingAndSales = 'MARKETING_AND_SALES',
  Other = 'OTHER',
  PersonalUse = 'PERSONAL_USE',
  Renovation = 'RENOVATION',
  StockPurchase = 'STOCK_PURCHASE',
  WorkingCapital = 'WORKING_CAPITAL'
}

export type LoanApplicationRef = {
  id?: Maybe<Scalars['ID']>;
};

export type LoanApplicationRefInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type LoanApplicationSpecificationInput = {
  companyDocument?: InputMaybe<Scalars['String']>;
  contactNumbers?: InputMaybe<Scalars['Int']>;
  currentPage: Scalars['Int'];
  endDate?: InputMaybe<Scalars['Date']>;
  insuranceAccepted?: InputMaybe<Scalars['Boolean']>;
  isOutBound?: InputMaybe<Scalars['Boolean']>;
  isRenewal?: InputMaybe<Scalars['Boolean']>;
  loanApplicationStatuses?: InputMaybe<Array<InputMaybe<LoanApplicationStatus>>>;
  pageSize: Scalars['Int'];
  productIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  salesAnalystNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<LoanApplicationSpecificationSort>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type LoanApplicationSpecificationSort = {
  isDescending?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<LoanApplicationSpecificationSortBy>;
};

export enum LoanApplicationSpecificationSortBy {
  Date = 'DATE',
  InsideSalesAnalyst = 'INSIDE_SALES_ANALYST',
  LastOfferAmount = 'LAST_OFFER_AMOUNT',
  UtmSource = 'UTM_SOURCE'
}

export enum LoanApplicationStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Closure = 'CLOSURE',
  Denied = 'DENIED',
  DocumentsPending = 'DOCUMENTS_PENDING',
  DocumentsReceived = 'DOCUMENTS_RECEIVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  InAnalysis = 'IN_ANALYSIS',
  Lost = 'LOST',
  Outsourced = 'OUTSOURCED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  RenewalAnalysis = 'RENEWAL_ANALYSIS',
  SignaturePending = 'SIGNATURE_PENDING',
  WaitingReceivables = 'WAITING_RECEIVABLES'
}

export enum LoginMode {
  EmailAndPassword = 'EMAIL_AND_PASSWORD',
  Facebook = 'FACEBOOK'
}

export enum LossReason {
  CompanyBankAccountNonexistent = 'COMPANY_BANK_ACCOUNT_NONEXISTENT',
  DealWithAnotherBank = 'DEAL_WITH_ANOTHER_BANK',
  DocsBureaucracy = 'DOCS_BUREAUCRACY',
  DropOut = 'DROP_OUT',
  HighCet = 'HIGH_CET',
  HighInterestRate = 'HIGH_INTEREST_RATE',
  LowValue = 'LOW_VALUE',
  NoReturn = 'NO_RETURN',
  OtherReason = 'OTHER_REASON',
  PriceQuotation = 'PRICE_QUOTATION',
  ShortPaymentDeadline = 'SHORT_PAYMENT_DEADLINE',
  WillWait = 'WILL_WAIT'
}

export type LowTicketType = {
  lowTicketScore?: Maybe<Scalars['Float']>;
};

export type MandatorySettlementArrangement = {
  arrangementCode?: Maybe<Scalars['String']>;
  arrangementType?: Maybe<ArrangementType>;
  freeTotalAmount?: Maybe<Scalars['Float']>;
  merchantDocumentNumber?: Maybe<Scalars['String']>;
  merchantName?: Maybe<Scalars['String']>;
  paymentNetwork?: Maybe<Scalars['String']>;
};

export type MdcSettings = {
  partnerPaysFees?: Maybe<Scalars['Boolean']>;
};

export type MetadataTag = {
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MoneyPlusInstitution = {
  bizId?: Maybe<FinancialInstitutionIdentification>;
  ccbNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Mutation = {
  addAmountRestriction?: Maybe<Array<Maybe<Coupon>>>;
  addAnnotation?: Maybe<LoanApplication>;
  addBorrowerExternalRelationship?: Maybe<LoanApplication>;
  addComissionDiscount?: Maybe<Array<Maybe<Coupon>>>;
  addCompanyUser?: Maybe<CompanyUserType>;
  addFollowUp?: Maybe<LoanApplication>;
  addGracePeriodDiscount?: Maybe<Array<Maybe<Coupon>>>;
  addInterestRateDiscount?: Maybe<Array<Maybe<Coupon>>>;
  addLoanAppliactionMcaEscrowAccount?: Maybe<LoanApplication>;
  addProposal?: Maybe<LoanApplication>;
  addTenureRestriction?: Maybe<Array<Maybe<Coupon>>>;
  allowDisbursementAuthorization?: Maybe<LoanApplication>;
  applyForCoupon?: Maybe<Scalars['Boolean']>;
  changeInsideSalesAnalyst?: Maybe<LoanApplication>;
  concludeLoanApplicationCreationById?: Maybe<Scalars['Boolean']>;
  continueLoanApplicationWorkFlow?: Maybe<LoanApplication>;
  createAnalyst?: Maybe<Analyst>;
  createBank?: Maybe<Bank>;
  createCity?: Maybe<City>;
  createCoupons?: Maybe<Scalars['Int']>;
  createCreditWorthiness?: Maybe<CreditWorthiness>;
  createLoanApplication?: Maybe<LoanApplication>;
  createLoanApplicationFromPreQualifiedLoan?: Maybe<LoanApplication>;
  createState?: Maybe<State>;
  createUser?: Maybe<User>;
  deleteAlienatedItem?: Maybe<LoanApplication>;
  disableCoupon?: Maybe<Array<Maybe<Coupon>>>;
  finishUserLivenessOnboarding?: Maybe<Liveness>;
  generateSharedUrl?: Maybe<LivenessSharedUrl>;
  handleLoanApproval?: Maybe<LoanApplication>;
  handleLoanCancelation?: Maybe<LoanApplication>;
  mockMandatorySettlementArrangement?: Maybe<Scalars['Boolean']>;
  notifyLoanApplicationCreated?: Maybe<LoanApplication>;
  notifyLoanApplicationCreatedById?: Maybe<LoanApplication>;
  removeAnnotation?: Maybe<LoanApplication>;
  removeEscrowAccountInfo?: Maybe<Scalars['Boolean']>;
  reprocessProductAssignment?: Maybe<Scalars['Boolean']>;
  revertLostLoanApplication?: Maybe<LoanApplication>;
  setAcceptedBizOsAccount?: Maybe<LoanApplication>;
  setAcceptedProposal?: Maybe<LoanApplication>;
  setAmountRequested?: Maybe<LoanApplication>;
  setBorrower?: Maybe<LoanApplication>;
  setBorrowerAddress?: Maybe<LoanApplication>;
  setBorrowerBankAccount?: Maybe<LoanApplication>;
  setBorrowerSimpleAddress?: Maybe<LoanApplication>;
  setBorrowerSimpleBankAccount?: Maybe<LoanApplication>;
  setBorrowerSimpleBankAccountCaaS?: Maybe<LoanApplication>;
  setCompanyInformation?: Maybe<LoanApplication>;
  setInsideSalesAnalyst?: Maybe<LoanApplication>;
  setLoss?: Maybe<LoanApplication>;
  setNotification?: Maybe<LoanApplication>;
  setNotifyViaWhatsapp?: Maybe<LoanApplication>;
  setProduct?: Maybe<Scalars['ID']>;
  setReasonForLoan?: Maybe<LoanApplication>;
  setRejection?: Maybe<LoanApplication>;
  setResponsibleInformation?: Maybe<LoanApplication>;
  setUtmsInfo?: Maybe<LoanApplication>;
  syncEscrowAccountData?: Maybe<Scalars['Boolean']>;
  trackClientIp?: Maybe<LoanApplication>;
  unsetCouponCode?: Maybe<UnsetCouponCodeResult>;
  updateAlienatedItem?: Maybe<LoanApplication>;
  updateAnalyst?: Maybe<Analyst>;
  updateBorrowerLegacyRelationship?: Maybe<LoanApplication>;
  updateEscrowAccountInfo?: Maybe<Scalars['Boolean']>;
  updateFinancialInstitution?: Maybe<LoanApplication>;
  updateLastProposalValues?: Maybe<LoanApplication>;
  updateLoanApplication?: Maybe<LoanApplication>;
  updateProductBaseSettings?: Maybe<Product>;
  updateProductISAnalysts?: Maybe<Product>;
  updateProductOutboundSettings?: Maybe<Product>;
  updateProductProgramConditions?: Maybe<Product>;
  updateStatusToDeniedRenewal?: Maybe<LoanApplication>;
  updateStatusToDocumentsPending?: Maybe<LoanApplication>;
};


export type MutationAddAmountRestrictionArgs = {
  code: Scalars['String'];
  restriction: AmountRestrictionInput;
};


export type MutationAddAnnotationArgs = {
  annotation: InsideSalesAnnotationInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationAddBorrowerExternalRelationshipArgs = {
  externalRelationship: ExternalRelationshipInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationAddComissionDiscountArgs = {
  code: Scalars['String'];
  discount: ComissionDiscountInput;
};


export type MutationAddCompanyUserArgs = {
  companyUser: CompanyUser;
};


export type MutationAddFollowUpArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationAddGracePeriodDiscountArgs = {
  code: Scalars['String'];
  discount: GracePeriodDiscountInput;
};


export type MutationAddInterestRateDiscountArgs = {
  code: Scalars['String'];
  discount: InterestRateDiscountInput;
};


export type MutationAddLoanAppliactionMcaEscrowAccountArgs = {
  merchantCashAdvanceLoanApplication: Scalars['ID'];
};


export type MutationAddProposalArgs = {
  automaticProposal: Scalars['Boolean'];
  loanApplicationId: Scalars['ID'];
  proposal: ProposalInput;
  requirePsychometric?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddTenureRestrictionArgs = {
  code: Scalars['String'];
  restriction: TenureRestrictionInput;
};


export type MutationAllowDisbursementAuthorizationArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationApplyForCouponArgs = {
  code: Scalars['String'];
  loanApplicationId: Scalars['ID'];
};


export type MutationChangeInsideSalesAnalystArgs = {
  loanApplicationId: Scalars['ID'];
  username: Scalars['String'];
};


export type MutationConcludeLoanApplicationCreationByIdArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationContinueLoanApplicationWorkFlowArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationCreateAnalystArgs = {
  analyst: AnalystInput;
};


export type MutationCreateBankArgs = {
  bank: BankInput;
};


export type MutationCreateCityArgs = {
  city: CityInput;
};


export type MutationCreateCouponsArgs = {
  coupon: CouponInput;
  quantity: Scalars['Int'];
};


export type MutationCreateCreditWorthinessArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationCreateLoanApplicationArgs = {
  loanApplication: LoanApplicationInput;
};


export type MutationCreateLoanApplicationFromPreQualifiedLoanArgs = {
  loanApplicationFromPreQualifiedInput: LoanApplicationFromPreQualifiedInput;
};


export type MutationCreateStateArgs = {
  state: StateInput;
};


export type MutationCreateUserArgs = {
  user: UserInput;
};


export type MutationDeleteAlienatedItemArgs = {
  alienatedItemId: Scalars['ID'];
  loanApplicationId: Scalars['ID'];
};


export type MutationDisableCouponArgs = {
  code: Scalars['String'];
};


export type MutationFinishUserLivenessOnboardingArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationGenerateSharedUrlArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationHandleLoanApprovalArgs = {
  firstPayment: Scalars['Date'];
  loanApplicationId: Scalars['ID'];
};


export type MutationHandleLoanCancelationArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationMockMandatorySettlementArrangementArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationNotifyLoanApplicationCreatedArgs = {
  loanApplication: LoanApplicationInput;
};


export type MutationNotifyLoanApplicationCreatedByIdArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationRemoveAnnotationArgs = {
  annotationId: Scalars['ID'];
  loanApplicationId: Scalars['ID'];
};


export type MutationRemoveEscrowAccountInfoArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationReprocessProductAssignmentArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationRevertLostLoanApplicationArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationSetAcceptedBizOsAccountArgs = {
  acceptedBizOsAccount: Scalars['Boolean'];
  loanApplicationId: Scalars['ID'];
};


export type MutationSetAcceptedProposalArgs = {
  insuranceAccepted?: InputMaybe<Scalars['Boolean']>;
  loanApplicationId: Scalars['ID'];
  proposal: ProposalInput;
};


export type MutationSetAmountRequestedArgs = {
  loanApplication: AmountRequestedInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetBorrowerArgs = {
  borrower: BorrowerInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetBorrowerAddressArgs = {
  address: AddressInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetBorrowerBankAccountArgs = {
  bankAccount: BankAccountInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetBorrowerSimpleAddressArgs = {
  address: SimpleAddressInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetBorrowerSimpleBankAccountArgs = {
  bankAccount: SimpleBankAccountInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetBorrowerSimpleBankAccountCaaSArgs = {
  bankAccount: SimpleBankAccountInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetCompanyInformationArgs = {
  borrower: CompanyInformationInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetInsideSalesAnalystArgs = {
  loanApplicationId: Scalars['ID'];
  username: Scalars['String'];
};


export type MutationSetLossArgs = {
  loanApplicationId: Scalars['ID'];
  lossReason: LossReason;
};


export type MutationSetNotificationArgs = {
  loanApplicationId: Scalars['ID'];
  notification?: InputMaybe<NotificationInput>;
};


export type MutationSetNotifyViaWhatsappArgs = {
  loanApplicationId: Scalars['ID'];
  notifyViaWhatsapp: Scalars['Boolean'];
};


export type MutationSetProductArgs = {
  loanApplicationId: Scalars['ID'];
  productBizId: Scalars['String'];
  reset?: InputMaybe<Scalars['Boolean']>;
  skipValidation?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetReasonForLoanArgs = {
  loanApplication: ReasonForLoanInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetRejectionArgs = {
  loanApplicationId: Scalars['ID'];
  rejection: RejectionInput;
};


export type MutationSetResponsibleInformationArgs = {
  borrower: ResponsibleInformationInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationSetUtmsInfoArgs = {
  loanApplicationId: Scalars['ID'];
  trackers?: InputMaybe<Scalars['String']>;
};


export type MutationSyncEscrowAccountDataArgs = {
  input: SyncEscrowAccountDataInput;
};


export type MutationTrackClientIpArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationUnsetCouponCodeArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateAlienatedItemArgs = {
  alienatedItem: AlienatedItemInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateAnalystArgs = {
  analyst: AnalystUpdateInput;
  id: Scalars['ID'];
};


export type MutationUpdateBorrowerLegacyRelationshipArgs = {
  legacyRelationship: LegacyRelationshipInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateEscrowAccountInfoArgs = {
  escrowBankAccount: EscrowBankAccountInput;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateFinancialInstitutionArgs = {
  financialInstitution: FinancialInstitutionIdentification;
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateLastProposalValuesArgs = {
  insuranceAccepted?: InputMaybe<Scalars['Boolean']>;
  loanApplicationId: Scalars['ID'];
  updatedProposal: ProposalInput;
};


export type MutationUpdateLoanApplicationArgs = {
  loanApplication: LoanApplicationInput;
};


export type MutationUpdateProductBaseSettingsArgs = {
  input: ProductBaseSettingsInput;
  productBizId: Scalars['String'];
};


export type MutationUpdateProductIsAnalystsArgs = {
  iSAnalystSettings: IsAnalystSettingsInput;
  productBizId: Scalars['String'];
};


export type MutationUpdateProductOutboundSettingsArgs = {
  outboundWindows: Array<OutboundWindowConfigInput>;
  productBizId: Scalars['String'];
};


export type MutationUpdateProductProgramConditionsArgs = {
  conditions: Array<ProductProgramConditionInput>;
  productBizId: Scalars['String'];
};


export type MutationUpdateStatusToDeniedRenewalArgs = {
  loanApplicationId: Scalars['ID'];
};


export type MutationUpdateStatusToDocumentsPendingArgs = {
  loanApplicationId: Scalars['ID'];
};

export type Notification = {
  notifyBorrower?: Maybe<Scalars['Boolean']>;
  notifyPartner?: Maybe<Scalars['Boolean']>;
  notifyViaWhatsapp?: Maybe<Scalars['Boolean']>;
};

export type NotificationInput = {
  notifyBorrower: Scalars['Boolean'];
  notifyPartner: Scalars['Boolean'];
};

export type OpenScdInstitution = {
  bizId?: Maybe<FinancialInstitutionIdentification>;
  ccbNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum OutboundLoanApplicationType {
  Any = 'ANY',
  FirstLoanOnly = 'FIRST_LOAN_ONLY',
  RenewalOnly = 'RENEWAL_ONLY'
}

export type OutboundWindowConfig = {
  enabled?: Maybe<Scalars['Boolean']>;
  loanApplicationType?: Maybe<OutboundLoanApplicationType>;
  windowDays?: Maybe<Scalars['Int']>;
};

export type OutboundWindowConfigInput = {
  enabled: Scalars['Boolean'];
  loanApplicationType: OutboundLoanApplicationType;
  windowDays: Scalars['Int'];
};

export type Partner = {
  id?: Maybe<Scalars['ID']>;
  status?: Maybe<PartnerStatus>;
};

export type PartnerRef = {
  bizId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export enum PartnerStatus {
  Active = 'ACTIVE',
  Analysing = 'ANALYSING',
  Pending = 'PENDING',
  Reproved = 'REPROVED',
  Waiting = 'WAITING'
}

export enum PaymentInterval {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type Person = {
  phone?: Maybe<Scalars['String']>;
  responsibleDocument?: Maybe<Scalars['String']>;
  responsibleName?: Maybe<Scalars['String']>;
};

export type PersonInput = {
  phone?: InputMaybe<Scalars['String']>;
  responsibleDocument?: InputMaybe<Scalars['String']>;
  responsibleName?: InputMaybe<Scalars['String']>;
};

export type PreQualifiedBorrowerInput = {
  companyDocument?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  monthlyRevenue?: InputMaybe<Scalars['Decimal']>;
  phone?: InputMaybe<Scalars['String']>;
  relationship?: InputMaybe<BorrowerRelationship>;
  responsibleDocument?: InputMaybe<Scalars['String']>;
  responsibleName?: InputMaybe<Scalars['String']>;
};

export type PreQualifiedLoan = {
  amount?: Maybe<Scalars['Float']>;
  document?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  interestRate?: Maybe<Scalars['Float']>;
  owner?: Maybe<PreQualifiedLoanOwner>;
  predefinedComissionPercent?: Maybe<Scalars['Float']>;
  status?: Maybe<PreQualifiedLoanStatus>;
  term?: Maybe<Scalars['Int']>;
};

export enum PreQualifiedLoanOwner {
  Ambev = 'AMBEV',
  Magalu = 'MAGALU',
  Wellhub = 'WELLHUB'
}

export enum PreQualifiedLoanStatus {
  Accepted = 'ACCEPTED',
  Awaiting = 'AWAITING',
  Denied = 'DENIED',
  Expired = 'EXPIRED'
}

export type PreQualifiedProposalType = {
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  interestRate?: Maybe<Scalars['Float']>;
  predefinedComissionPercent?: Maybe<Scalars['Float']>;
  term?: Maybe<Scalars['Int']>;
};

export type PreQualifiedTrackersInput = {
  sourceApi?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type PreQualifiedTrackingInput = {
  optInIp?: InputMaybe<Scalars['String']>;
  optInReceivablesLienAcceptance?: InputMaybe<Scalars['String']>;
  rawTrackers?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  trackers?: InputMaybe<PreQualifiedTrackersInput>;
};

export type PreviousApplication = {
  loanApplicationId?: Maybe<Scalars['ID']>;
  relationshipType?: Maybe<ApplicationRelationshipType>;
};

export type Product = {
  allowedBanks?: Maybe<Array<Maybe<Bank>>>;
  allowedInstitutions?: Maybe<Array<Maybe<FinancialInstitution>>>;
  allowsRepurchase?: Maybe<Scalars['Boolean']>;
  automaticDebitLiquidationMethod?: Maybe<AutomaticDebitLiquidationMethod>;
  automaticallyApplyForRenewal?: Maybe<Scalars['Boolean']>;
  bizId?: Maybe<Scalars['String']>;
  bizOnSettings?: Maybe<BizOnSettings>;
  canCoexistWith?: Maybe<Array<Maybe<Scalars['ID']>>>;
  coBrandUrl?: Maybe<Scalars['String']>;
  commissionSettings?: Maybe<ProductCommissionSettings>;
  considerGracePeriod?: Maybe<Scalars['Boolean']>;
  copyPreviousLoanData?: Maybe<Scalars['Boolean']>;
  creditor?: Maybe<Creditor>;
  dataFillOutFlow?: Maybe<Array<Maybe<DataFillOutFlowStep>>>;
  defaultFinancialInstitution?: Maybe<FinancialInstitutionIdentification>;
  feeSettings?: Maybe<ProductFeeSettings>;
  grace?: Maybe<Grace>;
  hasAntiFraudWorkflow?: Maybe<Scalars['Boolean']>;
  hasCollateral?: Maybe<Scalars['Boolean']>;
  hasDocumentationUploadWorkflow?: Maybe<Scalars['Boolean']>;
  iSAnalystSettings?: Maybe<IsAnalystSettings>;
  id?: Maybe<Scalars['ID']>;
  mainAllowedInstitution?: Maybe<FinancialInstitutionIdentification>;
  maxAbsoluteComission?: Maybe<Scalars['Float']>;
  maxAmountToRequest?: Maybe<Scalars['Decimal']>;
  maxConcurrentOperations?: Maybe<Scalars['Int']>;
  maxGracePeriodMonths?: Maybe<Scalars['Int']>;
  maxNumberOfInstallments?: Maybe<Scalars['Int']>;
  maxNumberOfInstallmentsForWeeklyInterval?: Maybe<Scalars['Int']>;
  maxProportionalComission?: Maybe<Scalars['Float']>;
  mdcSettings?: Maybe<MdcSettings>;
  minAmountToRequest?: Maybe<Scalars['Decimal']>;
  minInterestRate?: Maybe<Scalars['Decimal']>;
  minNumberOfInstallments?: Maybe<Scalars['Int']>;
  minNumberOfInstallmentsForWeeklyInterval?: Maybe<Scalars['Int']>;
  outboundWindows?: Maybe<Array<Maybe<OutboundWindowConfig>>>;
  paymentInterval?: Maybe<PaymentInterval>;
  productDefaults?: Maybe<ProductDefaults>;
  programConditions?: Maybe<Array<Maybe<ProductProgramCondition>>>;
  requiredDocumentation?: Maybe<Array<Maybe<DocumentType>>>;
  status?: Maybe<ProductStatus>;
  thirdPartyDisbursementDocument?: Maybe<Scalars['String']>;
  type?: Maybe<ProductType>;
};

export type ProductBaseSettingsInput = {
  allowsRepurchase?: InputMaybe<Scalars['Boolean']>;
  automaticallyApplyForRenewal?: InputMaybe<Scalars['Boolean']>;
  commissionSettings?: InputMaybe<ProductCommissionSettingsInput>;
  copyPreviousLoanData?: InputMaybe<Scalars['Boolean']>;
  feeSettings?: InputMaybe<ProductFeeSettingsInput>;
  hasAntiFraudWorkflow?: InputMaybe<Scalars['Boolean']>;
  hasCollateral?: InputMaybe<Scalars['Boolean']>;
  hasDocumentationUploadWorkflow?: InputMaybe<Scalars['Boolean']>;
  iSAnalystAutoAssignment?: InputMaybe<Scalars['Boolean']>;
  maxAbsoluteComission?: InputMaybe<Scalars['Float']>;
  maxAmountToRequest?: InputMaybe<Scalars['Decimal']>;
  maxConcurrentOperations?: InputMaybe<Scalars['Int']>;
  maxGracePeriodMonths?: InputMaybe<Scalars['Int']>;
  maxNumberOfInstallments?: InputMaybe<Scalars['Int']>;
  maxNumberOfInstallmentsForWeeklyInterval?: InputMaybe<Scalars['Int']>;
  maxProportionalComission?: InputMaybe<Scalars['Float']>;
  minAmountToRequest?: InputMaybe<Scalars['Decimal']>;
  minInterestRate?: InputMaybe<Scalars['Decimal']>;
  minNumberOfInstallments?: InputMaybe<Scalars['Int']>;
  minNumberOfInstallmentsForWeeklyInterval?: InputMaybe<Scalars['Int']>;
  paymentInterval?: InputMaybe<PaymentInterval>;
  productDefaults?: InputMaybe<ProductDefaultsInput>;
  status?: InputMaybe<ProductStatus>;
};

export type ProductCommissionSettings = {
  mode?: Maybe<CommissionMode>;
  rate?: Maybe<Scalars['Float']>;
};

export type ProductCommissionSettingsInput = {
  mode: CommissionMode;
  rate: Scalars['Float'];
};

export type ProductDefaults = {
  downPayments?: Maybe<Scalars['Int']>;
  guaranteeConcessionFee?: Maybe<Scalars['Decimal']>;
  guaranteeCoveragePercentage?: Maybe<Scalars['Decimal']>;
  structuringFee?: Maybe<Scalars['Decimal']>;
};

export type ProductDefaultsInput = {
  downPayments?: InputMaybe<Scalars['Int']>;
  guaranteeConcessionFee?: InputMaybe<Scalars['Decimal']>;
  guaranteeCoveragePercentage?: InputMaybe<Scalars['Decimal']>;
  structuringFee?: InputMaybe<Scalars['Decimal']>;
};

export type ProductFeeSettings = {
  hasIof?: Maybe<Scalars['Boolean']>;
  insuranceRate?: Maybe<Scalars['Float']>;
  registrationFeeRate?: Maybe<Scalars['Float']>;
};

export type ProductFeeSettingsInput = {
  hasIof: Scalars['Boolean'];
  insuranceRate: Scalars['Float'];
  registrationFeeRate: Scalars['Float'];
};

export type ProductFilterInput = {
  allowedInstitution?: InputMaybe<FinancialInstitutionIdentification>;
  status?: InputMaybe<ProductStatus>;
  type?: InputMaybe<ProductType>;
};

export type ProductIsAnalyst = {
  analystId?: Maybe<Scalars['ID']>;
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type ProductIsAnalystInput = {
  analystId: Scalars['ID'];
  enabled: Scalars['Boolean'];
};

export type ProductProgramCondition = {
  description?: Maybe<Scalars['String']>;
  guaranteeConcessionFee?: Maybe<Scalars['Decimal']>;
  guaranteeCoveragePercentage?: Maybe<Scalars['Decimal']>;
  key?: Maybe<Scalars['String']>;
};

export type ProductProgramConditionInput = {
  description?: InputMaybe<Scalars['String']>;
  guaranteeConcessionFee?: InputMaybe<Scalars['Decimal']>;
  guaranteeCoveragePercentage?: InputMaybe<Scalars['Decimal']>;
  key: Scalars['String'];
};

export type ProductRef = {
  bizId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export enum ProductStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export enum ProductType {
  BusinessLoan = 'BUSINESS_LOAN',
  Mdc = 'MDC',
  Receivables = 'RECEIVABLES'
}

export type Proposal = {
  amount?: Maybe<Scalars['Decimal']>;
  commission?: Maybe<Scalars['Decimal']>;
  date?: Maybe<Scalars['DateTime']>;
  downPaymentAmount?: Maybe<Scalars['Float']>;
  downPayments?: Maybe<Scalars['Int']>;
  fixedComission?: Maybe<Scalars['Boolean']>;
  fixedCommissionPercent?: Maybe<FixedCommissionPercent>;
  futureValue?: Maybe<Scalars['Float']>;
  guaranteeConcessionFee?: Maybe<Scalars['Decimal']>;
  guaranteeCoveragePercentage?: Maybe<Scalars['Decimal']>;
  hasRejectedDiscount?: Maybe<Scalars['Boolean']>;
  interestRate?: Maybe<Scalars['Decimal']>;
  legacyRelationship?: Maybe<LegacyRelationship>;
  minDownPaymentPercent?: Maybe<Scalars['Float']>;
  paymentDay?: Maybe<Scalars['Date']>;
  paymentInterval?: Maybe<PaymentInterval>;
  rejection?: Maybe<Rejection>;
  relevanceScore?: Maybe<Scalars['Decimal']>;
  structuringFee?: Maybe<Scalars['Decimal']>;
  tenure?: Maybe<Scalars['Int']>;
};

export type ProposalInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  commission?: InputMaybe<Scalars['Decimal']>;
  date?: InputMaybe<Scalars['DateTime']>;
  downPaymentAmount?: InputMaybe<Scalars['Float']>;
  downPayments?: InputMaybe<Scalars['Int']>;
  fixedComission?: InputMaybe<Scalars['Boolean']>;
  fixedCommissionPercent?: InputMaybe<FixedCommissionPercentInput>;
  guaranteeConcessionFee?: InputMaybe<Scalars['Decimal']>;
  guaranteeCoveragePercentage?: InputMaybe<Scalars['Decimal']>;
  hasRejectedDiscount?: InputMaybe<Scalars['Boolean']>;
  interestRate?: InputMaybe<Scalars['Decimal']>;
  legacyRelationship?: InputMaybe<LegacyRelationshipInput>;
  minDownPaymentPercent?: InputMaybe<Scalars['Float']>;
  paymentDay?: InputMaybe<Scalars['Date']>;
  paymentInterval?: InputMaybe<PaymentInterval>;
  rejection?: InputMaybe<RejectionInput>;
  structuringFee?: InputMaybe<Scalars['Decimal']>;
  tenure?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  antiFraud?: Maybe<AntiFraud>;
  availableCouponByCode?: Maybe<Coupon>;
  banks?: Maybe<Array<Maybe<Bank>>>;
  borrowerPositionByLoanApplicationId?: Maybe<BorrowerPosition>;
  canApplyForLoan?: Maybe<ApplyForLoanResult>;
  checkUserEmail?: Maybe<CheckUserEmailResult>;
  cities?: Maybe<Array<Maybe<City>>>;
  citiesByStateId?: Maybe<Array<Maybe<City>>>;
  cityByIbgeCode?: Maybe<City>;
  coupon?: Maybe<Array<Maybe<Coupon>>>;
  couponByLoan?: Maybe<Coupon>;
  couponPagination?: Maybe<CouponPagination>;
  creditWorthiness?: Maybe<CreditWorthiness>;
  getAllProductsMDC?: Maybe<Array<Maybe<Product>>>;
  getLoanApplicationHistory?: Maybe<Array<Maybe<LoanApplication>>>;
  getLoanApplications?: Maybe<LoanApplicationPagination>;
  getPartnerByBizId?: Maybe<Partner>;
  getProductByBizId?: Maybe<Product>;
  getProducts?: Maybe<Array<Maybe<Product>>>;
  getProductsByFilter?: Maybe<Array<Maybe<Product>>>;
  getSalesAnalysts?: Maybe<Array<Maybe<SalesAnalyst>>>;
  latestPreQualifiedLoan?: Maybe<PreQualifiedLoan>;
  leadStatistic?: Maybe<LeadStatistic>;
  loanApplication?: Maybe<LoanApplication>;
  loanApplicationByLeadId?: Maybe<LoanApplication>;
  loanApplicationByPreQualifiedLeadId?: Maybe<LoanApplication>;
  loanApplications?: Maybe<Array<Maybe<LoanApplication>>>;
  product?: Maybe<Product>;
  states?: Maybe<Array<Maybe<State>>>;
  userAccount?: Maybe<User>;
};


export type QueryAntiFraudArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryAvailableCouponByCodeArgs = {
  code: Scalars['String'];
};


export type QueryBorrowerPositionByLoanApplicationIdArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryCanApplyForLoanArgs = {
  cnpj: Scalars['String'];
};


export type QueryCheckUserEmailArgs = {
  email: Scalars['String'];
};


export type QueryCitiesByStateIdArgs = {
  stateId: Scalars['ID'];
};


export type QueryCityByIbgeCodeArgs = {
  ibgeCode: Scalars['String'];
};


export type QueryCouponArgs = {
  code: Scalars['String'];
};


export type QueryCouponByLoanArgs = {
  id: Scalars['ID'];
};


export type QueryCouponPaginationArgs = {
  current: Scalars['Int'];
  pageSize: Scalars['Int'];
};


export type QueryCreditWorthinessArgs = {
  loanApplicationId: Scalars['ID'];
};


export type QueryGetLoanApplicationHistoryArgs = {
  companyDocument: Scalars['String'];
};


export type QueryGetLoanApplicationsArgs = {
  queryParams: LoanApplicationSpecificationInput;
};


export type QueryGetPartnerByBizIdArgs = {
  bizId: Scalars['String'];
};


export type QueryGetProductByBizIdArgs = {
  productBizId: Scalars['String'];
};


export type QueryGetProductsByFilterArgs = {
  filter: ProductFilterInput;
};


export type QueryLatestPreQualifiedLoanArgs = {
  owner: PreQualifiedLoanOwner;
  preQualifiedLoanId: Scalars['ID'];
};


export type QueryLeadStatisticArgs = {
  id: Scalars['ID'];
};


export type QueryLoanApplicationArgs = {
  id: Scalars['ID'];
};


export type QueryLoanApplicationByLeadIdArgs = {
  leadId: Scalars['ID'];
};


export type QueryLoanApplicationByPreQualifiedLeadIdArgs = {
  id: Scalars['ID'];
};


export type QueryProductArgs = {
  productId: Scalars['ID'];
};


export type QueryUserAccountArgs = {
  cpf: Scalars['String'];
};

export type ReasonForLoanInput = {
  reason?: InputMaybe<LoanApplicationReason>;
  reasonDetail?: InputMaybe<Scalars['String']>;
};

export type Rejection = {
  details?: Maybe<Scalars['String']>;
  reason?: Maybe<RejectionReason>;
};

export type RejectionInput = {
  details?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<RejectionReason>;
};

export enum RejectionReason {
  AnotherProposal = 'ANOTHER_PROPOSAL',
  InterestRate = 'INTEREST_RATE',
  InDoubt = 'IN_DOUBT',
  StillThinking = 'STILL_THINKING',
  Tenure = 'TENURE',
  Value = 'VALUE'
}

export type RenewalInformation = {
  previousLoans?: Maybe<Array<Maybe<Scalars['ID']>>>;
  previousLoansCount?: Maybe<Scalars['Int']>;
};

export type RenewalScore = {
  indicator?: Maybe<Scalars['String']>;
  probability?: Maybe<Scalars['Float']>;
};

export type ResponsibleInformationInput = {
  email: Scalars['String'];
  phone: Scalars['String'];
  responsibleDocument: Scalars['String'];
  responsibleName: Scalars['String'];
};

export enum RestrictionApplicationMethod {
  Equal = 'EQUAL',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export type RestrictionType = AmountRestriction | TenureRestriction;

export type SalesAnalyst = {
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  login?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Serasa = {
  serasaScore?: Maybe<Scalars['Float']>;
  serasaVersion?: Maybe<Scalars['Int']>;
};

export type SimpleAddressInput = {
  cityCode: Scalars['String'];
  complement?: InputMaybe<Scalars['String']>;
  neighborhood: Scalars['String'];
  number: Scalars['String'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type SimpleBankAccountInput = {
  account: Scalars['String'];
  agency: Scalars['String'];
  bankCode: Scalars['String'];
};

export type SimulatedProposal = {
  amount?: Maybe<Scalars['Float']>;
  annualCet?: Maybe<Scalars['Float']>;
  comission?: Maybe<Scalars['Float']>;
  firstPayment?: Maybe<Scalars['DateTime']>;
  grossValue?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
  iof?: Maybe<Scalars['Float']>;
  loanDate?: Maybe<Scalars['DateTime']>;
  monthlyCet?: Maybe<Scalars['Float']>;
  paymentInterval?: Maybe<PaymentInterval>;
  pmt?: Maybe<Scalars['Float']>;
  simplesNacional?: Maybe<Scalars['Boolean']>;
  terms?: Maybe<Scalars['Int']>;
  totalPayment?: Maybe<Scalars['Float']>;
};

export type SimulatedProposals = {
  acceptedProposal?: Maybe<SimulatedProposal>;
  lastProposal?: Maybe<SimulatedProposal>;
  loanApplicationId?: Maybe<Scalars['ID']>;
};

export type SocinalInstitution = {
  bizId?: Maybe<FinancialInstitutionIdentification>;
  ccbNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type State = {
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type StateInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SyncEscrowAccountDataInput = {
  bizContaId?: InputMaybe<Scalars['ID']>;
  loanApplicationId: Scalars['ID'];
};

export type TenureRestriction = {
  applicationMethod?: Maybe<RestrictionApplicationMethod>;
  value: Scalars['Decimal'];
};

export type TenureRestrictionInput = {
  applicationMethod?: InputMaybe<RestrictionApplicationMethod>;
  value: Scalars['Decimal'];
};

export type Tracking = {
  insuranceOptIn?: Maybe<InsuranceOptIn>;
  optInIp?: Maybe<Scalars['String']>;
  optInReceivablesLienAcceptance?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  trackers?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
};

export type TrackingInput = {
  fingerPrint?: InputMaybe<Scalars['String']>;
  insuranceOptIn?: InputMaybe<InsuranceOptInInput>;
  optInIp?: InputMaybe<Scalars['String']>;
  optInReceivablesLienAcceptance?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  trackers?: InputMaybe<Scalars['String']>;
};

export type UnsetCouponCodeResult = {
  id?: Maybe<Scalars['ID']>;
};

export type User = {
  cpf?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  loginMode?: Maybe<LoginMode>;
  password?: Maybe<Scalars['String']>;
  person?: Maybe<Person>;
  thirdPartyId?: Maybe<Scalars['String']>;
};

export type UserInput = {
  cpf?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  loginMode?: InputMaybe<LoginMode>;
  password?: InputMaybe<Scalars['String']>;
  person?: InputMaybe<PersonInput>;
  thirdPartyId?: InputMaybe<Scalars['String']>;
};

export enum WorthyCreditStatus {
  Answered = 'ANSWERED',
  Draft = 'DRAFT',
  Generated = 'GENERATED',
  Processed = 'PROCESSED'
}

export type SetAcceptedProposalMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  proposal: ProposalInput;
  insuranceAccepted: Scalars['Boolean'];
}>;


export type SetAcceptedProposalMutation = { __typename: 'Mutation', setAcceptedProposal?: { __typename: 'LoanApplication', id?: string | null | undefined, proposals?: Array<{ __typename: 'Proposal', amount?: any | null | undefined, interestRate?: any | null | undefined, tenure?: number | null | undefined, paymentDay?: any | null | undefined, commission?: any | null | undefined, fixedComission?: boolean | null | undefined, date?: any | null | undefined, hasRejectedDiscount?: boolean | null | undefined, rejection?: { __typename: 'Rejection', reason?: RejectionReason | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetBorrowerAddressMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  address: AddressInput;
}>;


export type SetBorrowerAddressMutation = { __typename: 'Mutation', setBorrowerAddress?: { __typename: 'LoanApplication', id?: string | null | undefined, borrower?: { __typename: 'Borrower', address?: { __typename: 'Address', zipCode?: string | null | undefined, street?: string | null | undefined, number?: string | null | undefined, complement?: string | null | undefined, neighbourhood?: string | null | undefined, city?: { __typename: 'City', id?: string | null | undefined, name?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SetBorrowerBankAccountMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  bankAccount: BankAccountInput;
}>;


export type SetBorrowerBankAccountMutation = { __typename: 'Mutation', setBorrowerBankAccount?: { __typename: 'LoanApplication', id?: string | null | undefined, borrower?: { __typename: 'Borrower', bankAccount?: { __typename: 'BankAccount', agency?: string | null | undefined, account?: string | null | undefined, isLegalPersonAccount?: boolean | null | undefined, bankId?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type ContinueLoanApplicationWorkFlowMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type ContinueLoanApplicationWorkFlowMutation = { __typename: 'Mutation', continueLoanApplicationWorkFlow?: { __typename: 'LoanApplication', id?: string | null | undefined, couponCode?: string | null | undefined, status?: LoanApplicationStatus | null | undefined, acceptedProposal?: { __typename: 'Proposal', commission?: any | null | undefined, interestRate?: any | null | undefined, paymentDay?: any | null | undefined } | null | undefined } | null | undefined };

export type SetRejectionMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  rejection: RejectionInput;
}>;


export type SetRejectionMutation = { __typename: 'Mutation', setRejection?: { __typename: 'LoanApplication', id?: string | null | undefined, status?: LoanApplicationStatus | null | undefined } | null | undefined };

export type CreateLoanApplicationMutationVariables = Exact<{
  loanApplication: LoanApplicationInput;
}>;


export type CreateLoanApplicationMutation = { __typename: 'Mutation', createLoanApplication?: { __typename: 'LoanApplication', id?: string | null | undefined, amountRequested?: any | null | undefined } | null | undefined };

export type TrackClientIpMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type TrackClientIpMutation = { __typename: 'Mutation', trackClientIp?: { __typename: 'LoanApplication', id?: string | null | undefined, tracking?: { __typename: 'Tracking', optInIp?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateLoanApplicationMutationVariables = Exact<{
  loanApplication: LoanApplicationInput;
}>;


export type UpdateLoanApplicationMutation = { __typename: 'Mutation', updateLoanApplication?: { __typename: 'LoanApplication', id?: string | null | undefined } | null | undefined };

export type NotifyLoanApplicationCreatedMutationVariables = Exact<{
  loanApplication: LoanApplicationInput;
}>;


export type NotifyLoanApplicationCreatedMutation = { __typename: 'Mutation', notifyLoanApplicationCreated?: { __typename: 'LoanApplication', id?: string | null | undefined, status?: LoanApplicationStatus | null | undefined } | null | undefined };

export type NotifyLoanApplicationCreatedByIdMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type NotifyLoanApplicationCreatedByIdMutation = { __typename: 'Mutation', notifyLoanApplicationCreatedById?: { __typename: 'LoanApplication', id?: string | null | undefined } | null | undefined };

export type SetAmountRequestedMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  loanApplication: AmountRequestedInput;
}>;


export type SetAmountRequestedMutation = { __typename: 'Mutation', setAmountRequested?: { __typename: 'LoanApplication', id?: string | null | undefined, amountRequested?: any | null | undefined } | null | undefined };

export type SetReasonForLoanMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  loanApplication: ReasonForLoanInput;
}>;


export type SetReasonForLoanMutation = { __typename: 'Mutation', setReasonForLoan?: { __typename: 'LoanApplication', id?: string | null | undefined, reason?: LoanApplicationReason | null | undefined, reasonDetail?: string | null | undefined } | null | undefined };

export type SetCompanyInformationMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  borrower: CompanyInformationInput;
}>;


export type SetCompanyInformationMutation = { __typename: 'Mutation', setCompanyInformation?: { __typename: 'LoanApplication', id?: string | null | undefined, borrower?: { __typename: 'Borrower', companyDocument?: string | null | undefined, monthlyRevenue?: any | null | undefined, relationship?: BorrowerRelationship | null | undefined } | null | undefined } | null | undefined };

export type SetResponsibleInformationMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  borrower: ResponsibleInformationInput;
}>;


export type SetResponsibleInformationMutation = { __typename: 'Mutation', setResponsibleInformation?: { __typename: 'LoanApplication', id?: string | null | undefined, borrower?: { __typename: 'Borrower', responsibleName?: string | null | undefined, email?: string | null | undefined, responsibleDocument?: string | null | undefined, phone?: string | null | undefined } | null | undefined } | null | undefined };

export type SetUtmsInfoMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  trackers: Scalars['String'];
}>;


export type SetUtmsInfoMutation = { __typename: 'Mutation', setUtmsInfo?: { __typename: 'LoanApplication', id?: string | null | undefined, tracking?: { __typename: 'Tracking', trackers?: string | null | undefined } | null | undefined } | null | undefined };

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createUser?: { __typename: 'User', email?: string | null | undefined } | null | undefined };

export type ApplyForCouponMutationVariables = Exact<{
  code: Scalars['String'];
  loanApplicationId: Scalars['ID'];
}>;


export type ApplyForCouponMutation = { __typename: 'Mutation', applyForCoupon?: boolean | null | undefined };

export type UnsetCouponCodeMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type UnsetCouponCodeMutation = { __typename: 'Mutation', unsetCouponCode?: { __typename: 'UnsetCouponCodeResult', id?: string | null | undefined } | null | undefined };

export type SetNotificationMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  notification: NotificationInput;
}>;


export type SetNotificationMutation = { __typename: 'Mutation', setNotification?: { __typename: 'LoanApplication', id?: string | null | undefined, borrower?: { __typename: 'Borrower', responsibleName?: string | null | undefined, email?: string | null | undefined, responsibleDocument?: string | null | undefined, phone?: string | null | undefined } | null | undefined, notification?: { __typename: 'Notification', notifyBorrower?: boolean | null | undefined, notifyPartner?: boolean | null | undefined } | null | undefined } | null | undefined };

export type CreateLoanApplicationFromPreQualifiedLoanMutationVariables = Exact<{
  loanApplicationFromPreQualifiedInput: LoanApplicationFromPreQualifiedInput;
}>;


export type CreateLoanApplicationFromPreQualifiedLoanMutation = { __typename: 'Mutation', createLoanApplicationFromPreQualifiedLoan?: { __typename: 'LoanApplication', id?: string | null | undefined, product?: { __typename: 'Product', bizId?: string | null | undefined, dataFillOutFlow?: Array<{ __typename: 'DataFillOutFlowStep', routerPath?: string | null | undefined, order?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined, borrower?: { __typename: 'Borrower', companyDocument?: string | null | undefined } | null | undefined } | null | undefined };

export type UpdateLoanApplicationDataMutationMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  companyInformation: CompanyInformationInput;
  responsibleInformation: ResponsibleInformationInput;
}>;


export type UpdateLoanApplicationDataMutationMutation = { __typename: 'Mutation', setCompanyInformation?: { __typename: 'LoanApplication', id?: string | null | undefined } | null | undefined, setResponsibleInformation?: { __typename: 'LoanApplication', id?: string | null | undefined } | null | undefined };

export type GenerateSharedUrlMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type GenerateSharedUrlMutation = { __typename: 'Mutation', generateSharedUrl?: { __typename: 'LivenessSharedUrl', url?: string | null | undefined } | null | undefined };

export type FinishUserLivenessOnboardingMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type FinishUserLivenessOnboardingMutation = { __typename: 'Mutation', finishUserLivenessOnboarding?: { __typename: 'Liveness', status?: LivenessStatus | null | undefined } | null | undefined };

export type SetNotifyViaWhatsappMutationVariables = Exact<{
  loanApplicationId: Scalars['ID'];
  notifyViaWhatsapp: Scalars['Boolean'];
}>;


export type SetNotifyViaWhatsappMutation = { __typename: 'Mutation', setNotifyViaWhatsapp?: { __typename: 'LoanApplication', id?: string | null | undefined, borrower?: { __typename: 'Borrower', phone?: string | null | undefined } | null | undefined } | null | undefined };

export type SetAcceptedBizOsAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  acceptedBizOsAccount: Scalars['Boolean'];
}>;


export type SetAcceptedBizOsAccountMutation = { __typename: 'Mutation', setAcceptedBizOsAccount?: { __typename: 'LoanApplication', id?: string | null | undefined, acceptedBizOsAccount?: boolean | null | undefined } | null | undefined };

export type GetLoanQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLoanQuery = { __typename: 'Query', loanApplication?: { __typename: 'LoanApplication', id?: string | null | undefined, amountRequested?: any | null | undefined, downPayment?: number | null | undefined, status?: LoanApplicationStatus | null | undefined, couponCode?: string | null | undefined, hasRenegotiation?: boolean | null | undefined, hasAntiFraudWorkflow?: boolean | null | undefined, acceptedBizOsAccount?: boolean | null | undefined, hasDocumentationUploadWorkflow?: boolean | null | undefined, reason?: LoanApplicationReason | null | undefined, reasonDetail?: string | null | undefined, deniedReason?: LoanApplicationDeniedReason | null | undefined, isEligibleForInsurance?: boolean | null | undefined, hasRenewalInformation?: boolean | null | undefined, hasPreviousApplication?: boolean | null | undefined, proposals?: Array<{ __typename: 'Proposal', date?: any | null | undefined, interestRate?: any | null | undefined, hasRejectedDiscount?: boolean | null | undefined } | null | undefined> | null | undefined, lastProposal?: { __typename: 'Proposal', amount?: any | null | undefined, interestRate?: any | null | undefined, tenure?: number | null | undefined, paymentDay?: any | null | undefined, date?: any | null | undefined, commission?: any | null | undefined, fixedComission?: boolean | null | undefined, hasRejectedDiscount?: boolean | null | undefined, paymentInterval?: PaymentInterval | null | undefined, downPayments?: number | null | undefined, guaranteeConcessionFee?: any | null | undefined, fixedCommissionPercent?: { __typename: 'FixedCommissionPercent', fixedRate?: any | null | undefined } | null | undefined } | null | undefined, acceptedProposal?: { __typename: 'Proposal', amount?: any | null | undefined, downPaymentAmount?: number | null | undefined, interestRate?: any | null | undefined, tenure?: number | null | undefined, paymentDay?: any | null | undefined, date?: any | null | undefined, commission?: any | null | undefined, fixedComission?: boolean | null | undefined, paymentInterval?: PaymentInterval | null | undefined, downPayments?: number | null | undefined, fixedCommissionPercent?: { __typename: 'FixedCommissionPercent', fixedRate?: any | null | undefined } | null | undefined } | null | undefined, product?: { __typename: 'Product', bizId?: string | null | undefined, requiredDocumentation?: Array<DocumentType | null | undefined> | null | undefined, minNumberOfInstallments?: number | null | undefined, maxNumberOfInstallments?: number | null | undefined, dataFillOutFlow?: Array<{ __typename: 'DataFillOutFlowStep', routerPath?: string | null | undefined, order?: number | null | undefined } | null | undefined> | null | undefined, allowedBanks?: Array<{ __typename: 'Bank', id: string, code?: string | null | undefined, name?: string | null | undefined, mostUsed?: boolean | null | undefined } | null | undefined> | null | undefined, mdcSettings?: { __typename: 'MdcSettings', partnerPaysFees?: boolean | null | undefined } | null | undefined } | null | undefined, borrower?: { __typename: 'Borrower', responsibleDocument?: string | null | undefined, responsibleName?: string | null | undefined, companyDocument?: string | null | undefined, companyName?: string | null | undefined, simplesNacional?: boolean | null | undefined, monthlyRevenue?: any | null | undefined, relationship?: BorrowerRelationship | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, address?: { __typename: 'Address', zipCode?: string | null | undefined, street?: string | null | undefined, number?: string | null | undefined, complement?: string | null | undefined, neighbourhood?: string | null | undefined, city?: { __typename: 'City', id?: string | null | undefined, name?: string | null | undefined, state: { __typename: 'State', id?: string | null | undefined, name?: string | null | undefined, abbreviation?: string | null | undefined } } | null | undefined } | null | undefined, bankAccount?: { __typename: 'BankAccount', agency?: string | null | undefined, account?: string | null | undefined, bank?: { __typename: 'Bank', id: string, name?: string | null | undefined, code?: string | null | undefined, mostUsed?: boolean | null | undefined } | null | undefined } | null | undefined } | null | undefined, renewalInformation?: { __typename: 'RenewalInformation', previousLoansCount?: number | null | undefined } | null | undefined, tracking?: { __typename: 'Tracking', trackers?: string | null | undefined, insuranceOptIn?: { __typename: 'InsuranceOptIn', accepted?: boolean | null | undefined } | null | undefined } | null | undefined, notification?: { __typename: 'Notification', notifyBorrower?: boolean | null | undefined, notifyPartner?: boolean | null | undefined } | null | undefined, previousApplication?: { __typename: 'PreviousApplication', loanApplicationId?: string | null | undefined, relationshipType?: ApplicationRelationshipType | null | undefined } | null | undefined } | null | undefined };

export type GetStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatesQuery = { __typename: 'Query', states?: Array<{ __typename: 'State', id?: string | null | undefined, name?: string | null | undefined, abbreviation?: string | null | undefined } | null | undefined> | null | undefined };

export type GetCitiesQueryVariables = Exact<{
  stateId: Scalars['ID'];
}>;


export type GetCitiesQuery = { __typename: 'Query', citiesByStateId?: Array<{ __typename: 'City', id?: string | null | undefined, name?: string | null | undefined } | null | undefined> | null | undefined };

export type GetBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksQuery = { __typename: 'Query', banks?: Array<{ __typename: 'Bank', id: string, name?: string | null | undefined, code?: string | null | undefined, mostUsed?: boolean | null | undefined } | null | undefined> | null | undefined };

export type GetLoanStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLoanStatusQuery = { __typename: 'Query', loanApplication?: { __typename: 'LoanApplication', id?: string | null | undefined, status?: LoanApplicationStatus | null | undefined, deniedReason?: LoanApplicationDeniedReason | null | undefined } | null | undefined };

export type CanApplyForLoanQueryVariables = Exact<{
  cnpj: Scalars['String'];
}>;


export type CanApplyForLoanQuery = { __typename: 'Query', canApplyForLoan?: { __typename: 'ApplyForLoanResult', result?: boolean | null | undefined, cnpjErrorReason?: CnpjErrorReason | null | undefined, daysLeft?: number | null | undefined } | null | undefined };

export type UserAccountQueryVariables = Exact<{
  cpf: Scalars['String'];
}>;


export type UserAccountQuery = { __typename: 'Query', userAccount?: { __typename: 'User', id?: number | null | undefined, email?: string | null | undefined } | null | undefined };

export type AvailableCouponByCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type AvailableCouponByCodeQuery = { __typename: 'Query', availableCouponByCode?: { __typename: 'Coupon', discounts?: Array<{ __typename: 'ComissionDiscount', value?: any | null | undefined, applicationMethod?: DiscountApplicationMethod | null | undefined, allowsRenegotiation: boolean, fixedDate?: any | null | undefined, dateRanges?: Array<{ __typename: 'GracePeriodDiscountDateRange', minDate?: any | null | undefined, maxDate?: any | null | undefined, proposedPaymentDay?: any | null | undefined } | null | undefined> | null | undefined, additiveDate?: { __typename: 'GracePeriodDiscountAdditiveDate', applicationMethod?: AdditiveDateApplicationMethod | null | undefined, amount: number } | null | undefined } | { __typename: 'GracePeriodDiscount', value?: any | null | undefined, fixedDate?: any | null | undefined, applicationMethod?: DiscountApplicationMethod | null | undefined, allowsRenegotiation: boolean, dateRanges?: Array<{ __typename: 'GracePeriodDiscountDateRange', minDate?: any | null | undefined, maxDate?: any | null | undefined, proposedPaymentDay?: any | null | undefined } | null | undefined> | null | undefined, additiveDate?: { __typename: 'GracePeriodDiscountAdditiveDate', applicationMethod?: AdditiveDateApplicationMethod | null | undefined, amount: number } | null | undefined } | { __typename: 'InterestRateDiscount', value?: any | null | undefined, applicationMethod?: DiscountApplicationMethod | null | undefined, allowsRenegotiation: boolean, fixedDate?: any | null | undefined, dateRanges?: Array<{ __typename: 'GracePeriodDiscountDateRange', minDate?: any | null | undefined, maxDate?: any | null | undefined, proposedPaymentDay?: any | null | undefined } | null | undefined> | null | undefined, additiveDate?: { __typename: 'GracePeriodDiscountAdditiveDate', applicationMethod?: AdditiveDateApplicationMethod | null | undefined, amount: number } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CouponByLoanQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CouponByLoanQuery = { __typename: 'Query', couponByLoan?: { __typename: 'Coupon', discounts?: Array<{ __typename: 'ComissionDiscount', value?: any | null | undefined, applicationMethod?: DiscountApplicationMethod | null | undefined, allowsRenegotiation: boolean, fixedDate?: any | null | undefined, dateRanges?: Array<{ __typename: 'GracePeriodDiscountDateRange', minDate?: any | null | undefined, maxDate?: any | null | undefined, proposedPaymentDay?: any | null | undefined } | null | undefined> | null | undefined, additiveDate?: { __typename: 'GracePeriodDiscountAdditiveDate', applicationMethod?: AdditiveDateApplicationMethod | null | undefined, amount: number } | null | undefined } | { __typename: 'GracePeriodDiscount', value?: any | null | undefined, fixedDate?: any | null | undefined, applicationMethod?: DiscountApplicationMethod | null | undefined, allowsRenegotiation: boolean, dateRanges?: Array<{ __typename: 'GracePeriodDiscountDateRange', minDate?: any | null | undefined, maxDate?: any | null | undefined, proposedPaymentDay?: any | null | undefined } | null | undefined> | null | undefined, additiveDate?: { __typename: 'GracePeriodDiscountAdditiveDate', applicationMethod?: AdditiveDateApplicationMethod | null | undefined, amount: number } | null | undefined } | { __typename: 'InterestRateDiscount', value?: any | null | undefined, applicationMethod?: DiscountApplicationMethod | null | undefined, allowsRenegotiation: boolean, fixedDate?: any | null | undefined, dateRanges?: Array<{ __typename: 'GracePeriodDiscountDateRange', minDate?: any | null | undefined, maxDate?: any | null | undefined, proposedPaymentDay?: any | null | undefined } | null | undefined> | null | undefined, additiveDate?: { __typename: 'GracePeriodDiscountAdditiveDate', applicationMethod?: AdditiveDateApplicationMethod | null | undefined, amount: number } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetLeadStatisticQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLeadStatisticQuery = { __typename: 'Query', leadStatistic?: { __typename: 'LeadStatistic', conversionValue: number } | null | undefined };

export type LatestPreQualifiedLoanQueryVariables = Exact<{
  preQualifiedLoanId: Scalars['ID'];
  owner: PreQualifiedLoanOwner;
}>;


export type LatestPreQualifiedLoanQuery = { __typename: 'Query', latestPreQualifiedLoan?: { __typename: 'PreQualifiedLoan', id?: string | null | undefined, status?: PreQualifiedLoanStatus | null | undefined, predefinedComissionPercent?: number | null | undefined } | null | undefined };

export type LoanApplicationByPreQualifiedLeadIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LoanApplicationByPreQualifiedLeadIdQuery = { __typename: 'Query', loanApplicationByPreQualifiedLeadId?: { __typename: 'LoanApplication', id?: string | null | undefined, status?: LoanApplicationStatus | null | undefined } | null | undefined };

export type AntiFraudQueryVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type AntiFraudQuery = { __typename: 'Query', antiFraud?: { __typename: 'AntiFraud', livenessStatus?: LivenessStatus | null | undefined, worthyCreditStatus?: WorthyCreditStatus | null | undefined, isCompleted?: boolean | null | undefined, applicant?: { __typename: 'Applicant', relationship?: ApplicantRelationship | null | undefined } | null | undefined } | null | undefined };

export type BorrowerPositionByLoanApplicationIdQueryVariables = Exact<{
  loanApplicationId: Scalars['ID'];
}>;


export type BorrowerPositionByLoanApplicationIdQuery = { __typename: 'Query', borrowerPositionByLoanApplicationId?: BorrowerPosition | null | undefined };

export type GetPartnerByBizIdQueryVariables = Exact<{
  bizId: Scalars['String'];
}>;


export type GetPartnerByBizIdQuery = { __typename: 'Query', getPartnerByBizId?: { __typename: 'Partner', id?: string | null | undefined, status?: PartnerStatus | null | undefined } | null | undefined };


export const SetAcceptedProposalDocument = gql`
    mutation setAcceptedProposal($loanApplicationId: ID!, $proposal: ProposalInput!, $insuranceAccepted: Boolean!) {
  setAcceptedProposal(
    loanApplicationId: $loanApplicationId
    proposal: $proposal
    insuranceAccepted: $insuranceAccepted
  ) {
    id
    proposals {
      amount
      interestRate
      tenure
      paymentDay
      commission
      fixedComission
      date
      rejection {
        reason
      }
      hasRejectedDiscount
    }
  }
}
    `;
export type SetAcceptedProposalMutationFn = Apollo.MutationFunction<SetAcceptedProposalMutation, SetAcceptedProposalMutationVariables>;

/**
 * __useSetAcceptedProposalMutation__
 *
 * To run a mutation, you first call `useSetAcceptedProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAcceptedProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAcceptedProposalMutation, { data, loading, error }] = useSetAcceptedProposalMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      proposal: // value for 'proposal'
 *      insuranceAccepted: // value for 'insuranceAccepted'
 *   },
 * });
 */
export function useSetAcceptedProposalMutation(baseOptions?: Apollo.MutationHookOptions<SetAcceptedProposalMutation, SetAcceptedProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAcceptedProposalMutation, SetAcceptedProposalMutationVariables>(SetAcceptedProposalDocument, options);
      }
export type SetAcceptedProposalMutationHookResult = ReturnType<typeof useSetAcceptedProposalMutation>;
export type SetAcceptedProposalMutationResult = Apollo.MutationResult<SetAcceptedProposalMutation>;
export type SetAcceptedProposalMutationOptions = Apollo.BaseMutationOptions<SetAcceptedProposalMutation, SetAcceptedProposalMutationVariables>;
export const SetBorrowerAddressDocument = gql`
    mutation setBorrowerAddress($loanApplicationId: ID!, $address: AddressInput!) {
  setBorrowerAddress(loanApplicationId: $loanApplicationId, address: $address) {
    id
    borrower {
      address {
        zipCode
        street
        number
        complement
        neighbourhood
        city {
          id
          name
        }
      }
    }
  }
}
    `;
export type SetBorrowerAddressMutationFn = Apollo.MutationFunction<SetBorrowerAddressMutation, SetBorrowerAddressMutationVariables>;

/**
 * __useSetBorrowerAddressMutation__
 *
 * To run a mutation, you first call `useSetBorrowerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBorrowerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBorrowerAddressMutation, { data, loading, error }] = useSetBorrowerAddressMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useSetBorrowerAddressMutation(baseOptions?: Apollo.MutationHookOptions<SetBorrowerAddressMutation, SetBorrowerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBorrowerAddressMutation, SetBorrowerAddressMutationVariables>(SetBorrowerAddressDocument, options);
      }
export type SetBorrowerAddressMutationHookResult = ReturnType<typeof useSetBorrowerAddressMutation>;
export type SetBorrowerAddressMutationResult = Apollo.MutationResult<SetBorrowerAddressMutation>;
export type SetBorrowerAddressMutationOptions = Apollo.BaseMutationOptions<SetBorrowerAddressMutation, SetBorrowerAddressMutationVariables>;
export const SetBorrowerBankAccountDocument = gql`
    mutation setBorrowerBankAccount($loanApplicationId: ID!, $bankAccount: BankAccountInput!) {
  setBorrowerBankAccount(
    loanApplicationId: $loanApplicationId
    bankAccount: $bankAccount
  ) {
    id
    borrower {
      bankAccount {
        agency
        account
        isLegalPersonAccount
        bankId
      }
    }
  }
}
    `;
export type SetBorrowerBankAccountMutationFn = Apollo.MutationFunction<SetBorrowerBankAccountMutation, SetBorrowerBankAccountMutationVariables>;

/**
 * __useSetBorrowerBankAccountMutation__
 *
 * To run a mutation, you first call `useSetBorrowerBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBorrowerBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBorrowerBankAccountMutation, { data, loading, error }] = useSetBorrowerBankAccountMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      bankAccount: // value for 'bankAccount'
 *   },
 * });
 */
export function useSetBorrowerBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<SetBorrowerBankAccountMutation, SetBorrowerBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBorrowerBankAccountMutation, SetBorrowerBankAccountMutationVariables>(SetBorrowerBankAccountDocument, options);
      }
export type SetBorrowerBankAccountMutationHookResult = ReturnType<typeof useSetBorrowerBankAccountMutation>;
export type SetBorrowerBankAccountMutationResult = Apollo.MutationResult<SetBorrowerBankAccountMutation>;
export type SetBorrowerBankAccountMutationOptions = Apollo.BaseMutationOptions<SetBorrowerBankAccountMutation, SetBorrowerBankAccountMutationVariables>;
export const ContinueLoanApplicationWorkFlowDocument = gql`
    mutation continueLoanApplicationWorkFlow($loanApplicationId: ID!) {
  continueLoanApplicationWorkFlow(loanApplicationId: $loanApplicationId) {
    id
    couponCode
    status
    acceptedProposal {
      commission
      interestRate
      paymentDay
    }
  }
}
    `;
export type ContinueLoanApplicationWorkFlowMutationFn = Apollo.MutationFunction<ContinueLoanApplicationWorkFlowMutation, ContinueLoanApplicationWorkFlowMutationVariables>;

/**
 * __useContinueLoanApplicationWorkFlowMutation__
 *
 * To run a mutation, you first call `useContinueLoanApplicationWorkFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueLoanApplicationWorkFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueLoanApplicationWorkFlowMutation, { data, loading, error }] = useContinueLoanApplicationWorkFlowMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useContinueLoanApplicationWorkFlowMutation(baseOptions?: Apollo.MutationHookOptions<ContinueLoanApplicationWorkFlowMutation, ContinueLoanApplicationWorkFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueLoanApplicationWorkFlowMutation, ContinueLoanApplicationWorkFlowMutationVariables>(ContinueLoanApplicationWorkFlowDocument, options);
      }
export type ContinueLoanApplicationWorkFlowMutationHookResult = ReturnType<typeof useContinueLoanApplicationWorkFlowMutation>;
export type ContinueLoanApplicationWorkFlowMutationResult = Apollo.MutationResult<ContinueLoanApplicationWorkFlowMutation>;
export type ContinueLoanApplicationWorkFlowMutationOptions = Apollo.BaseMutationOptions<ContinueLoanApplicationWorkFlowMutation, ContinueLoanApplicationWorkFlowMutationVariables>;
export const SetRejectionDocument = gql`
    mutation setRejection($loanApplicationId: ID!, $rejection: RejectionInput!) {
  setRejection(loanApplicationId: $loanApplicationId, rejection: $rejection) {
    id
    status
  }
}
    `;
export type SetRejectionMutationFn = Apollo.MutationFunction<SetRejectionMutation, SetRejectionMutationVariables>;

/**
 * __useSetRejectionMutation__
 *
 * To run a mutation, you first call `useSetRejectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRejectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRejectionMutation, { data, loading, error }] = useSetRejectionMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      rejection: // value for 'rejection'
 *   },
 * });
 */
export function useSetRejectionMutation(baseOptions?: Apollo.MutationHookOptions<SetRejectionMutation, SetRejectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRejectionMutation, SetRejectionMutationVariables>(SetRejectionDocument, options);
      }
export type SetRejectionMutationHookResult = ReturnType<typeof useSetRejectionMutation>;
export type SetRejectionMutationResult = Apollo.MutationResult<SetRejectionMutation>;
export type SetRejectionMutationOptions = Apollo.BaseMutationOptions<SetRejectionMutation, SetRejectionMutationVariables>;
export const CreateLoanApplicationDocument = gql`
    mutation createLoanApplication($loanApplication: LoanApplicationInput!) {
  createLoanApplication(loanApplication: $loanApplication) {
    id
    amountRequested
  }
}
    `;
export type CreateLoanApplicationMutationFn = Apollo.MutationFunction<CreateLoanApplicationMutation, CreateLoanApplicationMutationVariables>;

/**
 * __useCreateLoanApplicationMutation__
 *
 * To run a mutation, you first call `useCreateLoanApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanApplicationMutation, { data, loading, error }] = useCreateLoanApplicationMutation({
 *   variables: {
 *      loanApplication: // value for 'loanApplication'
 *   },
 * });
 */
export function useCreateLoanApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoanApplicationMutation, CreateLoanApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoanApplicationMutation, CreateLoanApplicationMutationVariables>(CreateLoanApplicationDocument, options);
      }
export type CreateLoanApplicationMutationHookResult = ReturnType<typeof useCreateLoanApplicationMutation>;
export type CreateLoanApplicationMutationResult = Apollo.MutationResult<CreateLoanApplicationMutation>;
export type CreateLoanApplicationMutationOptions = Apollo.BaseMutationOptions<CreateLoanApplicationMutation, CreateLoanApplicationMutationVariables>;
export const TrackClientIpDocument = gql`
    mutation trackClientIp($loanApplicationId: ID!) {
  trackClientIp(loanApplicationId: $loanApplicationId) {
    id
    tracking {
      optInIp
    }
  }
}
    `;
export type TrackClientIpMutationFn = Apollo.MutationFunction<TrackClientIpMutation, TrackClientIpMutationVariables>;

/**
 * __useTrackClientIpMutation__
 *
 * To run a mutation, you first call `useTrackClientIpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackClientIpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackClientIpMutation, { data, loading, error }] = useTrackClientIpMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useTrackClientIpMutation(baseOptions?: Apollo.MutationHookOptions<TrackClientIpMutation, TrackClientIpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackClientIpMutation, TrackClientIpMutationVariables>(TrackClientIpDocument, options);
      }
export type TrackClientIpMutationHookResult = ReturnType<typeof useTrackClientIpMutation>;
export type TrackClientIpMutationResult = Apollo.MutationResult<TrackClientIpMutation>;
export type TrackClientIpMutationOptions = Apollo.BaseMutationOptions<TrackClientIpMutation, TrackClientIpMutationVariables>;
export const UpdateLoanApplicationDocument = gql`
    mutation updateLoanApplication($loanApplication: LoanApplicationInput!) {
  updateLoanApplication(loanApplication: $loanApplication) {
    id
  }
}
    `;
export type UpdateLoanApplicationMutationFn = Apollo.MutationFunction<UpdateLoanApplicationMutation, UpdateLoanApplicationMutationVariables>;

/**
 * __useUpdateLoanApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateLoanApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanApplicationMutation, { data, loading, error }] = useUpdateLoanApplicationMutation({
 *   variables: {
 *      loanApplication: // value for 'loanApplication'
 *   },
 * });
 */
export function useUpdateLoanApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanApplicationMutation, UpdateLoanApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanApplicationMutation, UpdateLoanApplicationMutationVariables>(UpdateLoanApplicationDocument, options);
      }
export type UpdateLoanApplicationMutationHookResult = ReturnType<typeof useUpdateLoanApplicationMutation>;
export type UpdateLoanApplicationMutationResult = Apollo.MutationResult<UpdateLoanApplicationMutation>;
export type UpdateLoanApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateLoanApplicationMutation, UpdateLoanApplicationMutationVariables>;
export const NotifyLoanApplicationCreatedDocument = gql`
    mutation notifyLoanApplicationCreated($loanApplication: LoanApplicationInput!) {
  notifyLoanApplicationCreated(loanApplication: $loanApplication) {
    id
    status
  }
}
    `;
export type NotifyLoanApplicationCreatedMutationFn = Apollo.MutationFunction<NotifyLoanApplicationCreatedMutation, NotifyLoanApplicationCreatedMutationVariables>;

/**
 * __useNotifyLoanApplicationCreatedMutation__
 *
 * To run a mutation, you first call `useNotifyLoanApplicationCreatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyLoanApplicationCreatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyLoanApplicationCreatedMutation, { data, loading, error }] = useNotifyLoanApplicationCreatedMutation({
 *   variables: {
 *      loanApplication: // value for 'loanApplication'
 *   },
 * });
 */
export function useNotifyLoanApplicationCreatedMutation(baseOptions?: Apollo.MutationHookOptions<NotifyLoanApplicationCreatedMutation, NotifyLoanApplicationCreatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyLoanApplicationCreatedMutation, NotifyLoanApplicationCreatedMutationVariables>(NotifyLoanApplicationCreatedDocument, options);
      }
export type NotifyLoanApplicationCreatedMutationHookResult = ReturnType<typeof useNotifyLoanApplicationCreatedMutation>;
export type NotifyLoanApplicationCreatedMutationResult = Apollo.MutationResult<NotifyLoanApplicationCreatedMutation>;
export type NotifyLoanApplicationCreatedMutationOptions = Apollo.BaseMutationOptions<NotifyLoanApplicationCreatedMutation, NotifyLoanApplicationCreatedMutationVariables>;
export const NotifyLoanApplicationCreatedByIdDocument = gql`
    mutation notifyLoanApplicationCreatedById($loanApplicationId: ID!) {
  notifyLoanApplicationCreatedById(loanApplicationId: $loanApplicationId) {
    id
  }
}
    `;
export type NotifyLoanApplicationCreatedByIdMutationFn = Apollo.MutationFunction<NotifyLoanApplicationCreatedByIdMutation, NotifyLoanApplicationCreatedByIdMutationVariables>;

/**
 * __useNotifyLoanApplicationCreatedByIdMutation__
 *
 * To run a mutation, you first call `useNotifyLoanApplicationCreatedByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyLoanApplicationCreatedByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyLoanApplicationCreatedByIdMutation, { data, loading, error }] = useNotifyLoanApplicationCreatedByIdMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useNotifyLoanApplicationCreatedByIdMutation(baseOptions?: Apollo.MutationHookOptions<NotifyLoanApplicationCreatedByIdMutation, NotifyLoanApplicationCreatedByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyLoanApplicationCreatedByIdMutation, NotifyLoanApplicationCreatedByIdMutationVariables>(NotifyLoanApplicationCreatedByIdDocument, options);
      }
export type NotifyLoanApplicationCreatedByIdMutationHookResult = ReturnType<typeof useNotifyLoanApplicationCreatedByIdMutation>;
export type NotifyLoanApplicationCreatedByIdMutationResult = Apollo.MutationResult<NotifyLoanApplicationCreatedByIdMutation>;
export type NotifyLoanApplicationCreatedByIdMutationOptions = Apollo.BaseMutationOptions<NotifyLoanApplicationCreatedByIdMutation, NotifyLoanApplicationCreatedByIdMutationVariables>;
export const SetAmountRequestedDocument = gql`
    mutation setAmountRequested($loanApplicationId: ID!, $loanApplication: AmountRequestedInput!) {
  setAmountRequested(
    loanApplicationId: $loanApplicationId
    loanApplication: $loanApplication
  ) {
    id
    amountRequested
  }
}
    `;
export type SetAmountRequestedMutationFn = Apollo.MutationFunction<SetAmountRequestedMutation, SetAmountRequestedMutationVariables>;

/**
 * __useSetAmountRequestedMutation__
 *
 * To run a mutation, you first call `useSetAmountRequestedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAmountRequestedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAmountRequestedMutation, { data, loading, error }] = useSetAmountRequestedMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      loanApplication: // value for 'loanApplication'
 *   },
 * });
 */
export function useSetAmountRequestedMutation(baseOptions?: Apollo.MutationHookOptions<SetAmountRequestedMutation, SetAmountRequestedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAmountRequestedMutation, SetAmountRequestedMutationVariables>(SetAmountRequestedDocument, options);
      }
export type SetAmountRequestedMutationHookResult = ReturnType<typeof useSetAmountRequestedMutation>;
export type SetAmountRequestedMutationResult = Apollo.MutationResult<SetAmountRequestedMutation>;
export type SetAmountRequestedMutationOptions = Apollo.BaseMutationOptions<SetAmountRequestedMutation, SetAmountRequestedMutationVariables>;
export const SetReasonForLoanDocument = gql`
    mutation setReasonForLoan($loanApplicationId: ID!, $loanApplication: ReasonForLoanInput!) {
  setReasonForLoan(
    loanApplicationId: $loanApplicationId
    loanApplication: $loanApplication
  ) {
    id
    reason
    reasonDetail
  }
}
    `;
export type SetReasonForLoanMutationFn = Apollo.MutationFunction<SetReasonForLoanMutation, SetReasonForLoanMutationVariables>;

/**
 * __useSetReasonForLoanMutation__
 *
 * To run a mutation, you first call `useSetReasonForLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReasonForLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReasonForLoanMutation, { data, loading, error }] = useSetReasonForLoanMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      loanApplication: // value for 'loanApplication'
 *   },
 * });
 */
export function useSetReasonForLoanMutation(baseOptions?: Apollo.MutationHookOptions<SetReasonForLoanMutation, SetReasonForLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReasonForLoanMutation, SetReasonForLoanMutationVariables>(SetReasonForLoanDocument, options);
      }
export type SetReasonForLoanMutationHookResult = ReturnType<typeof useSetReasonForLoanMutation>;
export type SetReasonForLoanMutationResult = Apollo.MutationResult<SetReasonForLoanMutation>;
export type SetReasonForLoanMutationOptions = Apollo.BaseMutationOptions<SetReasonForLoanMutation, SetReasonForLoanMutationVariables>;
export const SetCompanyInformationDocument = gql`
    mutation setCompanyInformation($loanApplicationId: ID!, $borrower: CompanyInformationInput!) {
  setCompanyInformation(
    loanApplicationId: $loanApplicationId
    borrower: $borrower
  ) {
    id
    borrower {
      companyDocument
      monthlyRevenue
      relationship
    }
  }
}
    `;
export type SetCompanyInformationMutationFn = Apollo.MutationFunction<SetCompanyInformationMutation, SetCompanyInformationMutationVariables>;

/**
 * __useSetCompanyInformationMutation__
 *
 * To run a mutation, you first call `useSetCompanyInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanyInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanyInformationMutation, { data, loading, error }] = useSetCompanyInformationMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      borrower: // value for 'borrower'
 *   },
 * });
 */
export function useSetCompanyInformationMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanyInformationMutation, SetCompanyInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanyInformationMutation, SetCompanyInformationMutationVariables>(SetCompanyInformationDocument, options);
      }
export type SetCompanyInformationMutationHookResult = ReturnType<typeof useSetCompanyInformationMutation>;
export type SetCompanyInformationMutationResult = Apollo.MutationResult<SetCompanyInformationMutation>;
export type SetCompanyInformationMutationOptions = Apollo.BaseMutationOptions<SetCompanyInformationMutation, SetCompanyInformationMutationVariables>;
export const SetResponsibleInformationDocument = gql`
    mutation setResponsibleInformation($loanApplicationId: ID!, $borrower: ResponsibleInformationInput!) {
  setResponsibleInformation(
    loanApplicationId: $loanApplicationId
    borrower: $borrower
  ) {
    id
    borrower {
      responsibleName
      email
      responsibleDocument
      phone
    }
  }
}
    `;
export type SetResponsibleInformationMutationFn = Apollo.MutationFunction<SetResponsibleInformationMutation, SetResponsibleInformationMutationVariables>;

/**
 * __useSetResponsibleInformationMutation__
 *
 * To run a mutation, you first call `useSetResponsibleInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetResponsibleInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setResponsibleInformationMutation, { data, loading, error }] = useSetResponsibleInformationMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      borrower: // value for 'borrower'
 *   },
 * });
 */
export function useSetResponsibleInformationMutation(baseOptions?: Apollo.MutationHookOptions<SetResponsibleInformationMutation, SetResponsibleInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetResponsibleInformationMutation, SetResponsibleInformationMutationVariables>(SetResponsibleInformationDocument, options);
      }
export type SetResponsibleInformationMutationHookResult = ReturnType<typeof useSetResponsibleInformationMutation>;
export type SetResponsibleInformationMutationResult = Apollo.MutationResult<SetResponsibleInformationMutation>;
export type SetResponsibleInformationMutationOptions = Apollo.BaseMutationOptions<SetResponsibleInformationMutation, SetResponsibleInformationMutationVariables>;
export const SetUtmsInfoDocument = gql`
    mutation setUtmsInfo($loanApplicationId: ID!, $trackers: String!) {
  setUtmsInfo(loanApplicationId: $loanApplicationId, trackers: $trackers) {
    id
    tracking {
      trackers
    }
  }
}
    `;
export type SetUtmsInfoMutationFn = Apollo.MutationFunction<SetUtmsInfoMutation, SetUtmsInfoMutationVariables>;

/**
 * __useSetUtmsInfoMutation__
 *
 * To run a mutation, you first call `useSetUtmsInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUtmsInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUtmsInfoMutation, { data, loading, error }] = useSetUtmsInfoMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      trackers: // value for 'trackers'
 *   },
 * });
 */
export function useSetUtmsInfoMutation(baseOptions?: Apollo.MutationHookOptions<SetUtmsInfoMutation, SetUtmsInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUtmsInfoMutation, SetUtmsInfoMutationVariables>(SetUtmsInfoDocument, options);
      }
export type SetUtmsInfoMutationHookResult = ReturnType<typeof useSetUtmsInfoMutation>;
export type SetUtmsInfoMutationResult = Apollo.MutationResult<SetUtmsInfoMutation>;
export type SetUtmsInfoMutationOptions = Apollo.BaseMutationOptions<SetUtmsInfoMutation, SetUtmsInfoMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($user: UserInput!) {
  createUser(user: $user) {
    email
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const ApplyForCouponDocument = gql`
    mutation applyForCoupon($code: String!, $loanApplicationId: ID!) {
  applyForCoupon(code: $code, loanApplicationId: $loanApplicationId)
}
    `;
export type ApplyForCouponMutationFn = Apollo.MutationFunction<ApplyForCouponMutation, ApplyForCouponMutationVariables>;

/**
 * __useApplyForCouponMutation__
 *
 * To run a mutation, you first call `useApplyForCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyForCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyForCouponMutation, { data, loading, error }] = useApplyForCouponMutation({
 *   variables: {
 *      code: // value for 'code'
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useApplyForCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplyForCouponMutation, ApplyForCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyForCouponMutation, ApplyForCouponMutationVariables>(ApplyForCouponDocument, options);
      }
export type ApplyForCouponMutationHookResult = ReturnType<typeof useApplyForCouponMutation>;
export type ApplyForCouponMutationResult = Apollo.MutationResult<ApplyForCouponMutation>;
export type ApplyForCouponMutationOptions = Apollo.BaseMutationOptions<ApplyForCouponMutation, ApplyForCouponMutationVariables>;
export const UnsetCouponCodeDocument = gql`
    mutation unsetCouponCode($loanApplicationId: ID!) {
  unsetCouponCode(loanApplicationId: $loanApplicationId) {
    id
  }
}
    `;
export type UnsetCouponCodeMutationFn = Apollo.MutationFunction<UnsetCouponCodeMutation, UnsetCouponCodeMutationVariables>;

/**
 * __useUnsetCouponCodeMutation__
 *
 * To run a mutation, you first call `useUnsetCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetCouponCodeMutation, { data, loading, error }] = useUnsetCouponCodeMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useUnsetCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<UnsetCouponCodeMutation, UnsetCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsetCouponCodeMutation, UnsetCouponCodeMutationVariables>(UnsetCouponCodeDocument, options);
      }
export type UnsetCouponCodeMutationHookResult = ReturnType<typeof useUnsetCouponCodeMutation>;
export type UnsetCouponCodeMutationResult = Apollo.MutationResult<UnsetCouponCodeMutation>;
export type UnsetCouponCodeMutationOptions = Apollo.BaseMutationOptions<UnsetCouponCodeMutation, UnsetCouponCodeMutationVariables>;
export const SetNotificationDocument = gql`
    mutation setNotification($loanApplicationId: ID!, $notification: NotificationInput!) {
  setNotification(
    loanApplicationId: $loanApplicationId
    notification: $notification
  ) {
    id
    borrower {
      responsibleName
      email
      responsibleDocument
      phone
    }
    notification {
      notifyBorrower
      notifyPartner
    }
  }
}
    `;
export type SetNotificationMutationFn = Apollo.MutationFunction<SetNotificationMutation, SetNotificationMutationVariables>;

/**
 * __useSetNotificationMutation__
 *
 * To run a mutation, you first call `useSetNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotificationMutation, { data, loading, error }] = useSetNotificationMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      notification: // value for 'notification'
 *   },
 * });
 */
export function useSetNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SetNotificationMutation, SetNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotificationMutation, SetNotificationMutationVariables>(SetNotificationDocument, options);
      }
export type SetNotificationMutationHookResult = ReturnType<typeof useSetNotificationMutation>;
export type SetNotificationMutationResult = Apollo.MutationResult<SetNotificationMutation>;
export type SetNotificationMutationOptions = Apollo.BaseMutationOptions<SetNotificationMutation, SetNotificationMutationVariables>;
export const CreateLoanApplicationFromPreQualifiedLoanDocument = gql`
    mutation createLoanApplicationFromPreQualifiedLoan($loanApplicationFromPreQualifiedInput: LoanApplicationFromPreQualifiedInput!) {
  createLoanApplicationFromPreQualifiedLoan(
    loanApplicationFromPreQualifiedInput: $loanApplicationFromPreQualifiedInput
  ) {
    id
    product {
      bizId
      dataFillOutFlow {
        routerPath
        order
      }
    }
    borrower {
      companyDocument
    }
  }
}
    `;
export type CreateLoanApplicationFromPreQualifiedLoanMutationFn = Apollo.MutationFunction<CreateLoanApplicationFromPreQualifiedLoanMutation, CreateLoanApplicationFromPreQualifiedLoanMutationVariables>;

/**
 * __useCreateLoanApplicationFromPreQualifiedLoanMutation__
 *
 * To run a mutation, you first call `useCreateLoanApplicationFromPreQualifiedLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoanApplicationFromPreQualifiedLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoanApplicationFromPreQualifiedLoanMutation, { data, loading, error }] = useCreateLoanApplicationFromPreQualifiedLoanMutation({
 *   variables: {
 *      loanApplicationFromPreQualifiedInput: // value for 'loanApplicationFromPreQualifiedInput'
 *   },
 * });
 */
export function useCreateLoanApplicationFromPreQualifiedLoanMutation(baseOptions?: Apollo.MutationHookOptions<CreateLoanApplicationFromPreQualifiedLoanMutation, CreateLoanApplicationFromPreQualifiedLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLoanApplicationFromPreQualifiedLoanMutation, CreateLoanApplicationFromPreQualifiedLoanMutationVariables>(CreateLoanApplicationFromPreQualifiedLoanDocument, options);
      }
export type CreateLoanApplicationFromPreQualifiedLoanMutationHookResult = ReturnType<typeof useCreateLoanApplicationFromPreQualifiedLoanMutation>;
export type CreateLoanApplicationFromPreQualifiedLoanMutationResult = Apollo.MutationResult<CreateLoanApplicationFromPreQualifiedLoanMutation>;
export type CreateLoanApplicationFromPreQualifiedLoanMutationOptions = Apollo.BaseMutationOptions<CreateLoanApplicationFromPreQualifiedLoanMutation, CreateLoanApplicationFromPreQualifiedLoanMutationVariables>;
export const UpdateLoanApplicationDataMutationDocument = gql`
    mutation updateLoanApplicationDataMutation($loanApplicationId: ID!, $companyInformation: CompanyInformationInput!, $responsibleInformation: ResponsibleInformationInput!) {
  setCompanyInformation(
    loanApplicationId: $loanApplicationId
    borrower: $companyInformation
  ) {
    id
  }
  setResponsibleInformation(
    loanApplicationId: $loanApplicationId
    borrower: $responsibleInformation
  ) {
    id
  }
}
    `;
export type UpdateLoanApplicationDataMutationMutationFn = Apollo.MutationFunction<UpdateLoanApplicationDataMutationMutation, UpdateLoanApplicationDataMutationMutationVariables>;

/**
 * __useUpdateLoanApplicationDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateLoanApplicationDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLoanApplicationDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLoanApplicationDataMutationMutation, { data, loading, error }] = useUpdateLoanApplicationDataMutationMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      companyInformation: // value for 'companyInformation'
 *      responsibleInformation: // value for 'responsibleInformation'
 *   },
 * });
 */
export function useUpdateLoanApplicationDataMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLoanApplicationDataMutationMutation, UpdateLoanApplicationDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLoanApplicationDataMutationMutation, UpdateLoanApplicationDataMutationMutationVariables>(UpdateLoanApplicationDataMutationDocument, options);
      }
export type UpdateLoanApplicationDataMutationMutationHookResult = ReturnType<typeof useUpdateLoanApplicationDataMutationMutation>;
export type UpdateLoanApplicationDataMutationMutationResult = Apollo.MutationResult<UpdateLoanApplicationDataMutationMutation>;
export type UpdateLoanApplicationDataMutationMutationOptions = Apollo.BaseMutationOptions<UpdateLoanApplicationDataMutationMutation, UpdateLoanApplicationDataMutationMutationVariables>;
export const GenerateSharedUrlDocument = gql`
    mutation generateSharedUrl($loanApplicationId: ID!) {
  generateSharedUrl(loanApplicationId: $loanApplicationId) {
    url
  }
}
    `;
export type GenerateSharedUrlMutationFn = Apollo.MutationFunction<GenerateSharedUrlMutation, GenerateSharedUrlMutationVariables>;

/**
 * __useGenerateSharedUrlMutation__
 *
 * To run a mutation, you first call `useGenerateSharedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSharedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSharedUrlMutation, { data, loading, error }] = useGenerateSharedUrlMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useGenerateSharedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSharedUrlMutation, GenerateSharedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSharedUrlMutation, GenerateSharedUrlMutationVariables>(GenerateSharedUrlDocument, options);
      }
export type GenerateSharedUrlMutationHookResult = ReturnType<typeof useGenerateSharedUrlMutation>;
export type GenerateSharedUrlMutationResult = Apollo.MutationResult<GenerateSharedUrlMutation>;
export type GenerateSharedUrlMutationOptions = Apollo.BaseMutationOptions<GenerateSharedUrlMutation, GenerateSharedUrlMutationVariables>;
export const FinishUserLivenessOnboardingDocument = gql`
    mutation finishUserLivenessOnboarding($loanApplicationId: ID!) {
  finishUserLivenessOnboarding(loanApplicationId: $loanApplicationId) {
    status
  }
}
    `;
export type FinishUserLivenessOnboardingMutationFn = Apollo.MutationFunction<FinishUserLivenessOnboardingMutation, FinishUserLivenessOnboardingMutationVariables>;

/**
 * __useFinishUserLivenessOnboardingMutation__
 *
 * To run a mutation, you first call `useFinishUserLivenessOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishUserLivenessOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishUserLivenessOnboardingMutation, { data, loading, error }] = useFinishUserLivenessOnboardingMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useFinishUserLivenessOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<FinishUserLivenessOnboardingMutation, FinishUserLivenessOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishUserLivenessOnboardingMutation, FinishUserLivenessOnboardingMutationVariables>(FinishUserLivenessOnboardingDocument, options);
      }
export type FinishUserLivenessOnboardingMutationHookResult = ReturnType<typeof useFinishUserLivenessOnboardingMutation>;
export type FinishUserLivenessOnboardingMutationResult = Apollo.MutationResult<FinishUserLivenessOnboardingMutation>;
export type FinishUserLivenessOnboardingMutationOptions = Apollo.BaseMutationOptions<FinishUserLivenessOnboardingMutation, FinishUserLivenessOnboardingMutationVariables>;
export const SetNotifyViaWhatsappDocument = gql`
    mutation setNotifyViaWhatsapp($loanApplicationId: ID!, $notifyViaWhatsapp: Boolean!) {
  setNotifyViaWhatsapp(
    loanApplicationId: $loanApplicationId
    notifyViaWhatsapp: $notifyViaWhatsapp
  ) {
    id
    borrower {
      phone
    }
  }
}
    `;
export type SetNotifyViaWhatsappMutationFn = Apollo.MutationFunction<SetNotifyViaWhatsappMutation, SetNotifyViaWhatsappMutationVariables>;

/**
 * __useSetNotifyViaWhatsappMutation__
 *
 * To run a mutation, you first call `useSetNotifyViaWhatsappMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotifyViaWhatsappMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotifyViaWhatsappMutation, { data, loading, error }] = useSetNotifyViaWhatsappMutation({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *      notifyViaWhatsapp: // value for 'notifyViaWhatsapp'
 *   },
 * });
 */
export function useSetNotifyViaWhatsappMutation(baseOptions?: Apollo.MutationHookOptions<SetNotifyViaWhatsappMutation, SetNotifyViaWhatsappMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNotifyViaWhatsappMutation, SetNotifyViaWhatsappMutationVariables>(SetNotifyViaWhatsappDocument, options);
      }
export type SetNotifyViaWhatsappMutationHookResult = ReturnType<typeof useSetNotifyViaWhatsappMutation>;
export type SetNotifyViaWhatsappMutationResult = Apollo.MutationResult<SetNotifyViaWhatsappMutation>;
export type SetNotifyViaWhatsappMutationOptions = Apollo.BaseMutationOptions<SetNotifyViaWhatsappMutation, SetNotifyViaWhatsappMutationVariables>;
export const SetAcceptedBizOsAccountDocument = gql`
    mutation setAcceptedBizOsAccount($id: ID!, $acceptedBizOsAccount: Boolean!) {
  setAcceptedBizOsAccount(
    loanApplicationId: $id
    acceptedBizOsAccount: $acceptedBizOsAccount
  ) {
    id
    acceptedBizOsAccount
  }
}
    `;
export type SetAcceptedBizOsAccountMutationFn = Apollo.MutationFunction<SetAcceptedBizOsAccountMutation, SetAcceptedBizOsAccountMutationVariables>;

/**
 * __useSetAcceptedBizOsAccountMutation__
 *
 * To run a mutation, you first call `useSetAcceptedBizOsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAcceptedBizOsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAcceptedBizOsAccountMutation, { data, loading, error }] = useSetAcceptedBizOsAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      acceptedBizOsAccount: // value for 'acceptedBizOsAccount'
 *   },
 * });
 */
export function useSetAcceptedBizOsAccountMutation(baseOptions?: Apollo.MutationHookOptions<SetAcceptedBizOsAccountMutation, SetAcceptedBizOsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAcceptedBizOsAccountMutation, SetAcceptedBizOsAccountMutationVariables>(SetAcceptedBizOsAccountDocument, options);
      }
export type SetAcceptedBizOsAccountMutationHookResult = ReturnType<typeof useSetAcceptedBizOsAccountMutation>;
export type SetAcceptedBizOsAccountMutationResult = Apollo.MutationResult<SetAcceptedBizOsAccountMutation>;
export type SetAcceptedBizOsAccountMutationOptions = Apollo.BaseMutationOptions<SetAcceptedBizOsAccountMutation, SetAcceptedBizOsAccountMutationVariables>;
export const GetLoanDocument = gql`
    query GetLoan($id: ID!) {
  loanApplication(id: $id) {
    id
    amountRequested
    downPayment
    status
    couponCode
    hasRenegotiation
    hasAntiFraudWorkflow
    acceptedBizOsAccount
    hasDocumentationUploadWorkflow
    reason
    reasonDetail
    deniedReason
    isEligibleForInsurance
    proposals {
      date
      interestRate
      hasRejectedDiscount
    }
    lastProposal {
      amount
      interestRate
      tenure
      paymentDay
      date
      commission
      fixedComission
      hasRejectedDiscount
      fixedCommissionPercent {
        fixedRate
      }
      paymentInterval
      downPayments
      guaranteeConcessionFee
    }
    acceptedProposal {
      amount
      downPaymentAmount
      interestRate
      tenure
      paymentDay
      date
      commission
      fixedComission
      fixedCommissionPercent {
        fixedRate
      }
      paymentInterval
      downPayments
    }
    product {
      bizId
      dataFillOutFlow {
        routerPath
        order
      }
      requiredDocumentation
      minNumberOfInstallments
      maxNumberOfInstallments
      allowedBanks {
        id
        code
        name
        mostUsed
      }
      mdcSettings {
        partnerPaysFees
      }
    }
    borrower {
      responsibleDocument
      responsibleName
      companyDocument
      companyName
      simplesNacional
      monthlyRevenue
      relationship
      email
      phone
      address {
        zipCode
        street
        number
        complement
        neighbourhood
        city {
          id
          name
          state {
            id
            name
            abbreviation
          }
        }
      }
      bankAccount {
        agency
        account
        bank {
          id
          name
          code
          mostUsed
        }
      }
    }
    renewalInformation {
      previousLoansCount
    }
    hasRenewalInformation
    hasPreviousApplication
    tracking {
      trackers
      insuranceOptIn {
        accepted
      }
    }
    notification {
      notifyBorrower
      notifyPartner
    }
    previousApplication {
      loanApplicationId
      relationshipType
    }
    hasPreviousApplication
  }
}
    `;

/**
 * __useGetLoanQuery__
 *
 * To run a query within a React component, call `useGetLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoanQuery(baseOptions: Apollo.QueryHookOptions<GetLoanQuery, GetLoanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanQuery, GetLoanQueryVariables>(GetLoanDocument, options);
      }
export function useGetLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanQuery, GetLoanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanQuery, GetLoanQueryVariables>(GetLoanDocument, options);
        }
export type GetLoanQueryHookResult = ReturnType<typeof useGetLoanQuery>;
export type GetLoanLazyQueryHookResult = ReturnType<typeof useGetLoanLazyQuery>;
export type GetLoanQueryResult = Apollo.QueryResult<GetLoanQuery, GetLoanQueryVariables>;
export const GetStatesDocument = gql`
    query GetStates {
  states {
    id
    name
    abbreviation
  }
}
    `;

/**
 * __useGetStatesQuery__
 *
 * To run a query within a React component, call `useGetStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatesQuery(baseOptions?: Apollo.QueryHookOptions<GetStatesQuery, GetStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatesQuery, GetStatesQueryVariables>(GetStatesDocument, options);
      }
export function useGetStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatesQuery, GetStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatesQuery, GetStatesQueryVariables>(GetStatesDocument, options);
        }
export type GetStatesQueryHookResult = ReturnType<typeof useGetStatesQuery>;
export type GetStatesLazyQueryHookResult = ReturnType<typeof useGetStatesLazyQuery>;
export type GetStatesQueryResult = Apollo.QueryResult<GetStatesQuery, GetStatesQueryVariables>;
export const GetCitiesDocument = gql`
    query GetCities($stateId: ID!) {
  citiesByStateId(stateId: $stateId) {
    id
    name
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      stateId: // value for 'stateId'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetBanksDocument = gql`
    query GetBanks {
  banks {
    id
    name
    code
    mostUsed
  }
}
    `;

/**
 * __useGetBanksQuery__
 *
 * To run a query within a React component, call `useGetBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBanksQuery(baseOptions?: Apollo.QueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
      }
export function useGetBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export type GetBanksQueryHookResult = ReturnType<typeof useGetBanksQuery>;
export type GetBanksLazyQueryHookResult = ReturnType<typeof useGetBanksLazyQuery>;
export type GetBanksQueryResult = Apollo.QueryResult<GetBanksQuery, GetBanksQueryVariables>;
export const GetLoanStatusDocument = gql`
    query GetLoanStatus($id: ID!) {
  loanApplication(id: $id) {
    id
    status
    deniedReason
  }
}
    `;

/**
 * __useGetLoanStatusQuery__
 *
 * To run a query within a React component, call `useGetLoanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLoanStatusQuery(baseOptions: Apollo.QueryHookOptions<GetLoanStatusQuery, GetLoanStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanStatusQuery, GetLoanStatusQueryVariables>(GetLoanStatusDocument, options);
      }
export function useGetLoanStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanStatusQuery, GetLoanStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanStatusQuery, GetLoanStatusQueryVariables>(GetLoanStatusDocument, options);
        }
export type GetLoanStatusQueryHookResult = ReturnType<typeof useGetLoanStatusQuery>;
export type GetLoanStatusLazyQueryHookResult = ReturnType<typeof useGetLoanStatusLazyQuery>;
export type GetLoanStatusQueryResult = Apollo.QueryResult<GetLoanStatusQuery, GetLoanStatusQueryVariables>;
export const CanApplyForLoanDocument = gql`
    query CanApplyForLoan($cnpj: String!) {
  canApplyForLoan(cnpj: $cnpj) {
    result
    cnpjErrorReason
    daysLeft
  }
}
    `;

/**
 * __useCanApplyForLoanQuery__
 *
 * To run a query within a React component, call `useCanApplyForLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanApplyForLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanApplyForLoanQuery({
 *   variables: {
 *      cnpj: // value for 'cnpj'
 *   },
 * });
 */
export function useCanApplyForLoanQuery(baseOptions: Apollo.QueryHookOptions<CanApplyForLoanQuery, CanApplyForLoanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanApplyForLoanQuery, CanApplyForLoanQueryVariables>(CanApplyForLoanDocument, options);
      }
export function useCanApplyForLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanApplyForLoanQuery, CanApplyForLoanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanApplyForLoanQuery, CanApplyForLoanQueryVariables>(CanApplyForLoanDocument, options);
        }
export type CanApplyForLoanQueryHookResult = ReturnType<typeof useCanApplyForLoanQuery>;
export type CanApplyForLoanLazyQueryHookResult = ReturnType<typeof useCanApplyForLoanLazyQuery>;
export type CanApplyForLoanQueryResult = Apollo.QueryResult<CanApplyForLoanQuery, CanApplyForLoanQueryVariables>;
export const UserAccountDocument = gql`
    query UserAccount($cpf: String!) {
  userAccount(cpf: $cpf) {
    id
    email
  }
}
    `;

/**
 * __useUserAccountQuery__
 *
 * To run a query within a React component, call `useUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountQuery({
 *   variables: {
 *      cpf: // value for 'cpf'
 *   },
 * });
 */
export function useUserAccountQuery(baseOptions: Apollo.QueryHookOptions<UserAccountQuery, UserAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccountQuery, UserAccountQueryVariables>(UserAccountDocument, options);
      }
export function useUserAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccountQuery, UserAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccountQuery, UserAccountQueryVariables>(UserAccountDocument, options);
        }
export type UserAccountQueryHookResult = ReturnType<typeof useUserAccountQuery>;
export type UserAccountLazyQueryHookResult = ReturnType<typeof useUserAccountLazyQuery>;
export type UserAccountQueryResult = Apollo.QueryResult<UserAccountQuery, UserAccountQueryVariables>;
export const AvailableCouponByCodeDocument = gql`
    query availableCouponByCode($code: String!) {
  availableCouponByCode(code: $code) {
    discounts {
      __typename
      ... on ComissionDiscount {
        value
        applicationMethod
        allowsRenegotiation
        fixedDate
        dateRanges {
          minDate
          maxDate
          proposedPaymentDay
        }
        additiveDate {
          applicationMethod
          amount
        }
      }
      ... on InterestRateDiscount {
        value
        applicationMethod
        allowsRenegotiation
        fixedDate
        dateRanges {
          minDate
          maxDate
          proposedPaymentDay
        }
        additiveDate {
          applicationMethod
          amount
        }
      }
      ... on GracePeriodDiscount {
        value
        fixedDate
        dateRanges {
          minDate
          maxDate
          proposedPaymentDay
        }
        additiveDate {
          applicationMethod
          amount
        }
        applicationMethod
        allowsRenegotiation
      }
    }
  }
}
    `;

/**
 * __useAvailableCouponByCodeQuery__
 *
 * To run a query within a React component, call `useAvailableCouponByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCouponByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCouponByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useAvailableCouponByCodeQuery(baseOptions: Apollo.QueryHookOptions<AvailableCouponByCodeQuery, AvailableCouponByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCouponByCodeQuery, AvailableCouponByCodeQueryVariables>(AvailableCouponByCodeDocument, options);
      }
export function useAvailableCouponByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCouponByCodeQuery, AvailableCouponByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCouponByCodeQuery, AvailableCouponByCodeQueryVariables>(AvailableCouponByCodeDocument, options);
        }
export type AvailableCouponByCodeQueryHookResult = ReturnType<typeof useAvailableCouponByCodeQuery>;
export type AvailableCouponByCodeLazyQueryHookResult = ReturnType<typeof useAvailableCouponByCodeLazyQuery>;
export type AvailableCouponByCodeQueryResult = Apollo.QueryResult<AvailableCouponByCodeQuery, AvailableCouponByCodeQueryVariables>;
export const CouponByLoanDocument = gql`
    query couponByLoan($id: ID!) {
  couponByLoan(id: $id) {
    discounts {
      __typename
      ... on ComissionDiscount {
        value
        applicationMethod
        allowsRenegotiation
        fixedDate
        dateRanges {
          minDate
          maxDate
          proposedPaymentDay
        }
        additiveDate {
          applicationMethod
          amount
        }
      }
      ... on InterestRateDiscount {
        value
        applicationMethod
        allowsRenegotiation
        fixedDate
        dateRanges {
          minDate
          maxDate
          proposedPaymentDay
        }
        additiveDate {
          applicationMethod
          amount
        }
      }
      ... on GracePeriodDiscount {
        value
        fixedDate
        dateRanges {
          minDate
          maxDate
          proposedPaymentDay
        }
        additiveDate {
          applicationMethod
          amount
        }
        applicationMethod
        allowsRenegotiation
      }
    }
  }
}
    `;

/**
 * __useCouponByLoanQuery__
 *
 * To run a query within a React component, call `useCouponByLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponByLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponByLoanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCouponByLoanQuery(baseOptions: Apollo.QueryHookOptions<CouponByLoanQuery, CouponByLoanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponByLoanQuery, CouponByLoanQueryVariables>(CouponByLoanDocument, options);
      }
export function useCouponByLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponByLoanQuery, CouponByLoanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponByLoanQuery, CouponByLoanQueryVariables>(CouponByLoanDocument, options);
        }
export type CouponByLoanQueryHookResult = ReturnType<typeof useCouponByLoanQuery>;
export type CouponByLoanLazyQueryHookResult = ReturnType<typeof useCouponByLoanLazyQuery>;
export type CouponByLoanQueryResult = Apollo.QueryResult<CouponByLoanQuery, CouponByLoanQueryVariables>;
export const GetLeadStatisticDocument = gql`
    query GetLeadStatistic($id: ID!) {
  leadStatistic(id: $id) {
    conversionValue
  }
}
    `;

/**
 * __useGetLeadStatisticQuery__
 *
 * To run a query within a React component, call `useGetLeadStatisticQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeadStatisticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeadStatisticQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLeadStatisticQuery(baseOptions: Apollo.QueryHookOptions<GetLeadStatisticQuery, GetLeadStatisticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeadStatisticQuery, GetLeadStatisticQueryVariables>(GetLeadStatisticDocument, options);
      }
export function useGetLeadStatisticLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeadStatisticQuery, GetLeadStatisticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeadStatisticQuery, GetLeadStatisticQueryVariables>(GetLeadStatisticDocument, options);
        }
export type GetLeadStatisticQueryHookResult = ReturnType<typeof useGetLeadStatisticQuery>;
export type GetLeadStatisticLazyQueryHookResult = ReturnType<typeof useGetLeadStatisticLazyQuery>;
export type GetLeadStatisticQueryResult = Apollo.QueryResult<GetLeadStatisticQuery, GetLeadStatisticQueryVariables>;
export const LatestPreQualifiedLoanDocument = gql`
    query LatestPreQualifiedLoan($preQualifiedLoanId: ID!, $owner: PreQualifiedLoanOwner!) {
  latestPreQualifiedLoan(preQualifiedLoanId: $preQualifiedLoanId, owner: $owner) {
    id
    status
    predefinedComissionPercent
  }
}
    `;

/**
 * __useLatestPreQualifiedLoanQuery__
 *
 * To run a query within a React component, call `useLatestPreQualifiedLoanQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestPreQualifiedLoanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestPreQualifiedLoanQuery({
 *   variables: {
 *      preQualifiedLoanId: // value for 'preQualifiedLoanId'
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useLatestPreQualifiedLoanQuery(baseOptions: Apollo.QueryHookOptions<LatestPreQualifiedLoanQuery, LatestPreQualifiedLoanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestPreQualifiedLoanQuery, LatestPreQualifiedLoanQueryVariables>(LatestPreQualifiedLoanDocument, options);
      }
export function useLatestPreQualifiedLoanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestPreQualifiedLoanQuery, LatestPreQualifiedLoanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestPreQualifiedLoanQuery, LatestPreQualifiedLoanQueryVariables>(LatestPreQualifiedLoanDocument, options);
        }
export type LatestPreQualifiedLoanQueryHookResult = ReturnType<typeof useLatestPreQualifiedLoanQuery>;
export type LatestPreQualifiedLoanLazyQueryHookResult = ReturnType<typeof useLatestPreQualifiedLoanLazyQuery>;
export type LatestPreQualifiedLoanQueryResult = Apollo.QueryResult<LatestPreQualifiedLoanQuery, LatestPreQualifiedLoanQueryVariables>;
export const LoanApplicationByPreQualifiedLeadIdDocument = gql`
    query LoanApplicationByPreQualifiedLeadId($id: ID!) {
  loanApplicationByPreQualifiedLeadId(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useLoanApplicationByPreQualifiedLeadIdQuery__
 *
 * To run a query within a React component, call `useLoanApplicationByPreQualifiedLeadIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoanApplicationByPreQualifiedLeadIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoanApplicationByPreQualifiedLeadIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoanApplicationByPreQualifiedLeadIdQuery(baseOptions: Apollo.QueryHookOptions<LoanApplicationByPreQualifiedLeadIdQuery, LoanApplicationByPreQualifiedLeadIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoanApplicationByPreQualifiedLeadIdQuery, LoanApplicationByPreQualifiedLeadIdQueryVariables>(LoanApplicationByPreQualifiedLeadIdDocument, options);
      }
export function useLoanApplicationByPreQualifiedLeadIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoanApplicationByPreQualifiedLeadIdQuery, LoanApplicationByPreQualifiedLeadIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoanApplicationByPreQualifiedLeadIdQuery, LoanApplicationByPreQualifiedLeadIdQueryVariables>(LoanApplicationByPreQualifiedLeadIdDocument, options);
        }
export type LoanApplicationByPreQualifiedLeadIdQueryHookResult = ReturnType<typeof useLoanApplicationByPreQualifiedLeadIdQuery>;
export type LoanApplicationByPreQualifiedLeadIdLazyQueryHookResult = ReturnType<typeof useLoanApplicationByPreQualifiedLeadIdLazyQuery>;
export type LoanApplicationByPreQualifiedLeadIdQueryResult = Apollo.QueryResult<LoanApplicationByPreQualifiedLeadIdQuery, LoanApplicationByPreQualifiedLeadIdQueryVariables>;
export const AntiFraudDocument = gql`
    query AntiFraud($loanApplicationId: ID!) {
  antiFraud(loanApplicationId: $loanApplicationId) {
    livenessStatus
    worthyCreditStatus
    applicant {
      relationship
    }
    isCompleted
  }
}
    `;

/**
 * __useAntiFraudQuery__
 *
 * To run a query within a React component, call `useAntiFraudQuery` and pass it any options that fit your needs.
 * When your component renders, `useAntiFraudQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAntiFraudQuery({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useAntiFraudQuery(baseOptions: Apollo.QueryHookOptions<AntiFraudQuery, AntiFraudQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AntiFraudQuery, AntiFraudQueryVariables>(AntiFraudDocument, options);
      }
export function useAntiFraudLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AntiFraudQuery, AntiFraudQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AntiFraudQuery, AntiFraudQueryVariables>(AntiFraudDocument, options);
        }
export type AntiFraudQueryHookResult = ReturnType<typeof useAntiFraudQuery>;
export type AntiFraudLazyQueryHookResult = ReturnType<typeof useAntiFraudLazyQuery>;
export type AntiFraudQueryResult = Apollo.QueryResult<AntiFraudQuery, AntiFraudQueryVariables>;
export const BorrowerPositionByLoanApplicationIdDocument = gql`
    query BorrowerPositionByLoanApplicationId($loanApplicationId: ID!) {
  borrowerPositionByLoanApplicationId(loanApplicationId: $loanApplicationId)
}
    `;

/**
 * __useBorrowerPositionByLoanApplicationIdQuery__
 *
 * To run a query within a React component, call `useBorrowerPositionByLoanApplicationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBorrowerPositionByLoanApplicationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBorrowerPositionByLoanApplicationIdQuery({
 *   variables: {
 *      loanApplicationId: // value for 'loanApplicationId'
 *   },
 * });
 */
export function useBorrowerPositionByLoanApplicationIdQuery(baseOptions: Apollo.QueryHookOptions<BorrowerPositionByLoanApplicationIdQuery, BorrowerPositionByLoanApplicationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BorrowerPositionByLoanApplicationIdQuery, BorrowerPositionByLoanApplicationIdQueryVariables>(BorrowerPositionByLoanApplicationIdDocument, options);
      }
export function useBorrowerPositionByLoanApplicationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BorrowerPositionByLoanApplicationIdQuery, BorrowerPositionByLoanApplicationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BorrowerPositionByLoanApplicationIdQuery, BorrowerPositionByLoanApplicationIdQueryVariables>(BorrowerPositionByLoanApplicationIdDocument, options);
        }
export type BorrowerPositionByLoanApplicationIdQueryHookResult = ReturnType<typeof useBorrowerPositionByLoanApplicationIdQuery>;
export type BorrowerPositionByLoanApplicationIdLazyQueryHookResult = ReturnType<typeof useBorrowerPositionByLoanApplicationIdLazyQuery>;
export type BorrowerPositionByLoanApplicationIdQueryResult = Apollo.QueryResult<BorrowerPositionByLoanApplicationIdQuery, BorrowerPositionByLoanApplicationIdQueryVariables>;
export const GetPartnerByBizIdDocument = gql`
    query GetPartnerByBizId($bizId: String!) {
  getPartnerByBizId(bizId: $bizId) {
    id
    status
  }
}
    `;

/**
 * __useGetPartnerByBizIdQuery__
 *
 * To run a query within a React component, call `useGetPartnerByBizIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerByBizIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerByBizIdQuery({
 *   variables: {
 *      bizId: // value for 'bizId'
 *   },
 * });
 */
export function useGetPartnerByBizIdQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerByBizIdQuery, GetPartnerByBizIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerByBizIdQuery, GetPartnerByBizIdQueryVariables>(GetPartnerByBizIdDocument, options);
      }
export function useGetPartnerByBizIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerByBizIdQuery, GetPartnerByBizIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerByBizIdQuery, GetPartnerByBizIdQueryVariables>(GetPartnerByBizIdDocument, options);
        }
export type GetPartnerByBizIdQueryHookResult = ReturnType<typeof useGetPartnerByBizIdQuery>;
export type GetPartnerByBizIdLazyQueryHookResult = ReturnType<typeof useGetPartnerByBizIdLazyQuery>;
export type GetPartnerByBizIdQueryResult = Apollo.QueryResult<GetPartnerByBizIdQuery, GetPartnerByBizIdQueryVariables>;